

import React, { useState, useContext, useEffect, useRef } from 'react';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import isEqual from 'lodash.isequal';
import { Accordion, Form, Button, Table, Row, Col, FormSelect, Tab, ListGroup, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import AuthContext from '../../context/AuthContext';
import axiosInstance from '../../utils/axios';
import { formatDisplayDate } from '../../utils/formatter';
import { fnFormValidation, fnMobileNumberValidation, fnEmailValidation } from '../reusables/HelperFormValidation';
import { showToast } from '../reusables/CommonFunction';
import { Menu, Pill, UserRound, MessageSquareText, Activity, Route, Baby, Stethoscope, Layers, ClipboardPenLine, NotepadText, Images, ClipboardList, CalendarDays, Smile } from 'lucide-react';
import PrescriptionModal from './prescription/PrescriptionModal';
import BusyLoaderOverlay from '../reusables/BusyLoaderOverlay';
import ModalICD from '../reusables/ModalICD';
import ModalMedicine from '../reusables/ModalMedicine';
import ModalDelete from '../reusables/ModalDelete';
import CustomTimePicker from '../reusables/CustomTimePicker';
import DentalChart from './dentist/DentalChart';
import PreviousDentalChart from './dentist/PreviousDentalChart';

const NewPatient = () => {
    const fileInputRef = useRef(null);
    let { userDetails, clinicBranchDetails } = useContext(AuthContext)
    let todayDate = new Date()
    const padZero = (value) => value.toString().padStart(2, '0');
    const currentMonth = padZero(todayDate.getMonth() + 1);
    const currentDate = padZero(todayDate.getDate());
    const currentDateFormat = `${todayDate.getFullYear()}-${currentMonth}-${currentDate}`;

    const params = useParams()
    const { state } = useLocation()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true)
    const [isPatientSaved, setIsPatientSaved] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState({});
    const [isDeleteFileModalOpen, setIsDeleteFileModalOpen] = useState(false);
    const [prescriptionDetails, setPrescriptionDetails] = useState({});
    const [isPrescriptionModalOpen, setPrescriptionModalOpen] = useState(false);
    const [isMedicineModalOpen, setMedicineModalOpen] = useState(false);
    const [activeRxType, setActiveRxType] = useState('')
    const [isPatientAdult, setPatientAdult] = useState(state?.age === undefined ? true : state?.age >= 18 ? true : false)
    const [isPatientMarried, setPatientMarried] = useState(false)
    const [behaviourSpeech, setBehaviourSpeech] = useState([])
    const [behaviourFeeding, setBehaviourFeeding] = useState([])
    const [behaviourFeedingProblem, setBehaviourFeedingProblem] = useState([])
    const [developmentalBehaviour, setDevelopmentalBehaviour] = useState({
        babbling: false,
        words: false,
        sentences: false,
        retarded: false,
        breast: false,
        top_dilution: false,
        bottle: false,
        solids: false,
        colic: false,
        underfeeding: false,
        overfeeding: false,
        regurgitation: false,
        loose_stools: false,
        constipation: false
    })

    const [appointmentDetails, setAppointmentDetails] = useState({
        clinic_id: state?.clinic_id === undefined ? "" : state?.clinic_id,
        clinic_branch_id: state?.clinic_branch_id === undefined ? "" : state?.clinic_branch_id,
        visitor_id: state?.visitor_id === undefined ? "" : state?.visitor_id,
        slug: state?.slug === undefined ? "" : state?.slug,
        salutation: state?.salutation === undefined ? "" : state?.salutation,
        visitor_name: state?.visitor_name === undefined ? "" : state?.visitor_name,
        visitor_type: state?.visitor_type === undefined ? "" : state?.visitor_type,
        patient_case_number: state?.patient_case_number === undefined ? "" : state?.patient_case_number,
        accompanied_by: state?.accompanied_by === undefined ? "" : state?.accompanied_by,
        referred_by: state?.referred_by === undefined ? "" : state?.referred_by,
        age: state?.age === undefined ? "" : state?.age,
        gender: state?.gender === undefined ? "" : state?.gender,
        marital_status: state?.marital_status === undefined ? "" : state?.marital_status,
        married_since: state?.married_since === undefined ? "" : state?.married_since,
        name_of_parent_if_minor: state?.name_of_parent_if_minor === undefined ? "" : state?.name_of_parent_if_minor,
        mobile_number: state?.mobile_number === undefined ? "" : state?.mobile_number,
        email_id: state?.email_id === undefined ? "" : state?.email_id,
        patient_address: state?.patient_address === undefined ? "" : state?.patient_address,
        patient_city: state?.patient_city === undefined ? "" : state?.patient_city,
        appointment_date: state?.appointment_date === undefined ? "" : state?.appointment_date,
        appointment_time: state?.appointment_time === undefined ? "" : state?.appointment_time,
        status: state?.status === undefined ? "" : state?.status,
    })
    const [personalInformation, setPersonalInformation] = useState({
        clinic_id: userDetails.clinic_id,
        clinic_branch_id: state?.clinic_branch_id === undefined ? "" : state?.clinic_branch_id,
        visit_date: currentDateFormat,
        amount: "",
        amount_paid_via: "cash",
        patient_case_number: state?.patient_case_number === undefined ? "" : state?.patient_case_number,
        salutation: state?.salutation === undefined ? "" : state?.salutation,
        patient_name: state?.visitor_name === undefined ? "" : state?.visitor_name,
        accompanied_by: state?.accompanied_by === undefined ? "" : state?.accompanied_by,
        referred_by: state?.referred_by === undefined ? "" : state?.referred_by,
        age: state?.age === undefined ? "" : state?.age,
        gender: state?.gender === undefined ? "" : state?.gender,
        marital_status: state?.marital_status === undefined ? "" : state?.marital_status,
        married_since: state?.married_since === undefined ? "" : state?.married_since,
        name_of_parent_if_minor: state?.name_of_parent_if_minor === undefined ? "" : state?.name_of_parent_if_minor,
        mobile_number: state?.mobile_number === undefined ? "" : state?.mobile_number,
        alternate_mobile_number: "",
        email_id: state?.email_id === undefined ? "" : state?.email_id,
        blood_group: "",
        education: "",
        occupation: "",
        past_history: "",
        family_history: "",
        patient_address: state?.patient_address === undefined ? "" : state?.patient_address,
        patient_city: state?.patient_city === undefined ? "" : state?.patient_city,
        life_space_childhood: "",
        life_space_adulthood: "",
        life_space_old_age: "",
        life_space_interpersonal: "",
        life_space_other_notes: "",
        spouse_name: "",
        spouse_age: "",
        spouse_mobile_number: "",
        spouse_occupation: ""
    })
    const [personalInformationErrors, setPersonalInformationErrors] = useState({
        clinic_id: "",
        clinic_branch_id: "",
        visit_date: "",
        amount: "",
        amount_paid_via: "",
        patient_case_number: "",
        salutation: "",
        patient_name: "",
        accompanied_by: "",
        referred_by: "",
        age: "",
        gender: "",
        marital_status: "",
        married_since: "",
        name_of_parent_if_minor: "",
        mobile_number: "",
        alternate_mobile_number: "",
        email_id: "",
        blood_group: "",
        education: "",
        occupation: "",
        past_history: "",
        family_history: "",
        patient_address: "",
        patient_city: "",
        life_space_childhood: "",
        life_space_adulthood: "",
        life_space_old_age: "",
        life_space_interpersonal: "",
        life_space_other_notes: "",
        spouse_name: "",
        spouse_age: "",
        spouse_mobile_number: "",
        spouse_occupation: ""
    })

    const [complaintsChief, setComplaintsChief] = useState([{}])
    const [complaintsAssociated, setComplaintsAssociated] = useState([{}])
    const [chiefComplaints, setChiefComplaints] = useState([{}])
    const [associatedComplaints, setAssociatedComplaints] = useState([{}])
    const [dentalChartType, setDentalChartType] = useState('adult')
    const [dentalChart, setDentalChart] = useState({})
    const [previousDentalChart, setPreviousDentalChart] = useState([])

    const [physicalCharacteristics, setPhysicalCharacteristics] = useState({
        appearance: "",
        perspiration: "",
        hunger: "",
        appetite: "",
        thirst: "",
        cravings: "",
        aversions: "",
        disagree: "",
        thermal: "",
        stool: "",
        urine: "",
        menstrual_function: "",
        sexual_function: "",
        sensory_sensitivity: "",
        sleep: "",
        dreams: "",
        hobbies: "",
        addictions: ""
    })

    const [childProblems, setChildProblems] = useState({
        physical_development: "",
        mental_development: "",
        recognition_objects: "",
        social_smile: "",
        head: "",
        abdomen: "",
        fontanellae: "",
        head_holding: "",
        turning_prine: "",
        sitting: "",
        crawling: "",
        standing: "",
        walking: "",
        object_grasp: "",
        hand_to_hand_transfer: "",
        pincer_movement: "",
        remove_clothes_shoes: "",
        puts_on_clothes_shoes: "",
        socialization: "",
        speech: "",
        feeding: "",
        feeding_problems: ""
    })

    const [physicalExamination, setPhysicalExamination] = useState({
        weight: "",
        height: "",
        tempature: "",
        pulse: "",
        bp: "",
        rs: "",
        cvs: "",
        cns: "",
        pa: "",
        appearance: "",
        behaviour: "",
        speech: "",
        mood: "",
        thought: "",
        perception: "",
        memory: "",
        orientation: "",
        insight_judgement: "",
        teeth: "",
        extra_oral: "",
        intra_oral: "",
        tongue: "",
        gums: "",
        palate: "",
        pharynx: "",
        tonsils: "",
        uvula: "",
        others: ""
    })

    const [totality, setTotality] = useState([{}])

    const [diagnosisRemedy, setDiagnosisRemedy] = useState({
        diagnosis_1: "",
        diagnosis_2: "",
        diagnosis_3: "",
        diagnosis_4: "",
        investigation: "",
        remedy: "",
        advice: "",
        next_appointment_date: null,
        next_appointment_time: null
    })
    const [nextVisitPlan, setNextVisitPlan] = useState({
        next_appointment_date: "",
        next_appointment_time: ""
    })
    const [isNextAppointmentDisabled, setIsNextAppointmentDisabled] = useState(false)

    const [otherNotes, setOtherNotes] = useState([{}])
    const [followUpEvaluation, setFollowUpEvaluation] = useState([{}])

    const [formFile, setFormFile] = useState({ file_url: null, file_name: '', upload_date: currentDateFormat, remark: '' });
    const [patientFiles, setPatientFiles] = useState([])
    const [followUp, setFollowUp] = useState([{}])
    const [prevFollowUp, setPrevFollowUp] = useState([{}]);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [previewFileType, setPreviewFileType] = useState(null);
    const [showFileModal, setShowFileModal] = useState(false);
    const [patientIdForFile, setPatientIdForFile] = useState(null);

    const mappedPreviewFileType = (type) => {
        switch (type) {
            case "Image":
                return "image";
            case "PDF":
                return "pdf";
            case "Word Document":
                return "word";
            case "Excel Spreadsheet":
                return "excel";
            case "PowerPoint Presentation":
                return "powerpoint";
            default:
                return "other";
        }
    };

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const menuItems = [
        { key: "#personal-info", label: "Personal Information", icon: <UserRound size={18} /> },
        { key: "#complaints", label: "Complaints", icon: <MessageSquareText size={18} />, hide: userDetails.clinic_type === "HM" },
        { key: "#present-history", label: "Present History", icon: <MessageSquareText size={18} />, hide: userDetails.clinic_type !== "HM" },
        { key: "#physical-char", label: "Physical Characteristics", icon: <Activity size={18} />, hide: userDetails.clinic_type !== "HM" },
        { key: "#life-space", label: "Life Space", icon: <Route size={18} />, hide: userDetails.clinic_type !== "HM" },
        { key: "#child-problem", label: "Development Problems", icon: <Baby size={18} />, hide: userDetails.doctor_type === "dentist" || isPatientAdult },
        { key: "#examination", label: "Examination", icon: <Stethoscope size={18} /> },
        { key: "#dental-examination", label: "Dental Examination", icon: <Smile size={18} />, hide: userDetails.doctor_type !== "dentist" },
        { key: "#totality", label: "Totality", icon: <Layers size={18} />, hide: userDetails.clinic_type !== "HM" },
        { key: "#diagnosis", label: "Diagnosis / Rx", icon: <ClipboardPenLine size={18} /> },
        { key: "#other-notes", label: "Other Notes", icon: <NotepadText size={18} />, hide: userDetails.clinic_type === "HM" },
        // { key: "#files", label: "Files", icon: <Images size={18} />, hide: true },
        { key: "#files", label: "Files", icon: <Images size={18} />, hide: !(userDetails.plan_type === "P" && userDetails.is_clinic_plan_expired === false) },
        { key: "#evaluation", label: "Follow Up Evaluation", icon: <ClipboardList size={18} />, hide: userDetails.clinic_type !== "HM" },
        { key: "#follow-up", label: "Follow Up", icon: <CalendarDays size={18} /> },
    ];

    const onChange = (oEvent, pCurrentState, pSetCurrentState, pCurrentErrorState, pSetCurrentErrorState) => {
        let { name, value } = oEvent.target;

        if (name === "patient_case_number" || name === "patient_name" || name === "accompanied_by" || name === "referred_by" || name === "name_of_parent_if_minor" || name === "spouse_name") {
            value = value.toUpperCase()
        }
        pSetCurrentState({ ...pCurrentState, [name]: value, });
        if (pCurrentErrorState !== undefined && !!pCurrentErrorState[name]) {
            pSetCurrentErrorState({ ...pCurrentErrorState, [name]: null });
        }

        if (name === 'marital_status') {
            pSetCurrentState(pCurrentState => ({ ...pCurrentState, ['married_since']: '' }))
            pSetCurrentState(pCurrentState => ({ ...pCurrentState, ['spouse_name']: '' }))
            pSetCurrentState(pCurrentState => ({ ...pCurrentState, ['spouse_age']: '' }))
            pSetCurrentState(pCurrentState => ({ ...pCurrentState, ['spouse_mobile_number']: '' }))
            pSetCurrentState(pCurrentState => ({ ...pCurrentState, ['spouse_occupation']: '' }))

            if (value === "M") {
                setPatientMarried(true)
            } else {
                setPatientMarried(false)
            }
        }
    };

    const onFocusOut = (oEvent, pCurrentState, pSetCurrentState) => {
        if (oEvent.target.name === 'age') {
            if (Number(oEvent.target.value) < 18) {
                setPatientAdult(false)
            } else {
                setPatientAdult(true)
                pSetCurrentState({ ...pCurrentState, ['name_of_parent_if_minor']: '' })
            }

            if (Number(oEvent.target.value) <= 6) {
                setDentalChartType('child')
            } else if (Number(oEvent.target.value) > 6 && Number(oEvent.target.value) <= 12) {
                setDentalChartType('teenage')
            } else {
                setDentalChartType('adult')
            }
        }
    };

    /* Add Row to the Table */
    const onPressTableRowAdd = (pTableScreen) => {
        if (pTableScreen === "complaintsChief") {
            setComplaintsChief([
                ...complaintsChief, {
                    "complaints_chief": ""
                }
            ])
        } else if (pTableScreen === "complaintsAssociated") {
            setComplaintsAssociated([
                ...complaintsAssociated, {
                    "complaints_associated": ""
                }
            ])
        } else if (pTableScreen === "chiefComplaints") {
            setChiefComplaints([
                ...chiefComplaints, {
                    "location": "",
                    "sensation_pathology": "",
                    "modalities": "",
                    "accompaniments": ""
                }
            ])
        } else if (pTableScreen === "associatedComplaints") {
            setAssociatedComplaints([
                ...associatedComplaints, {
                    "location": "",
                    "sensation_pathology": "",
                    "modalities": "",
                    "accompaniments": ""
                }
            ])
        } else if (pTableScreen === "totality") {
            setTotality([
                ...totality, {
                    "totality": ""
                }
            ])
        } else if (pTableScreen === "otherNotes") {
            setOtherNotes([
                ...otherNotes, {
                    "other_notes": ""
                }
            ])
        } else if (pTableScreen === "followUpEvaluation") {
            setFollowUpEvaluation([
                ...followUpEvaluation, {
                    "follow_up_evaluation": ""
                }
            ])
        } else if (pTableScreen === "followUp") {
            setFollowUp([
                ...followUp, {
                    "follow_up_date": "",
                    "follow_up": "",
                    "remedy": "",
                    "advice": "",
                    "amount": "",
                    "amount_paid_via": "cash",
                    "next_appointment_date": "",
                    "next_appointment_time": ""
                }
            ])
        }
    };

    const onCheckboxChange = (oEvent) => {
        const { name, checked } = oEvent.target

        if (checked) {
            switch (name) {
                case "babbling":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['babbling']: true });
                    setBehaviourSpeech([...behaviourSpeech, "B"]);
                    break

                case "words":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['words']: true });
                    setBehaviourSpeech([...behaviourSpeech, "W"]);
                    break

                case "sentences":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['sentences']: true });
                    setBehaviourSpeech([...behaviourSpeech, "S"]);
                    break

                case "retarded":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['retarded']: true });
                    setBehaviourSpeech([...behaviourSpeech, "R"]);
                    break

                case "breast":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['breast']: true });
                    setBehaviourFeeding([...behaviourFeeding, "BR"]);
                    break

                case "top_dilution":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['top_dilution']: true });
                    setBehaviourFeeding([...behaviourFeeding, "T"]);
                    break

                case "bottle":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['bottle']: true });
                    setBehaviourFeeding([...behaviourFeeding, "BO"]);
                    break

                case "solids":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['solids']: true });
                    setBehaviourFeeding([...behaviourFeeding, "S"]);
                    break

                case "colic":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['colic']: true });
                    setBehaviourFeedingProblem([...behaviourFeedingProblem, "CL"]);
                    break

                case "underfeeding":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['underfeeding']: true });
                    setBehaviourFeedingProblem([...behaviourFeedingProblem, "U"]);
                    break

                case "overfeeding":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['overfeeding']: true });
                    setBehaviourFeedingProblem([...behaviourFeedingProblem, "O"]);
                    break

                case "regurgitation":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['regurgitation']: true });
                    setBehaviourFeedingProblem([...behaviourFeedingProblem, "R"]);
                    break

                case "loose_stools":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['loose_stools']: true });
                    setBehaviourFeedingProblem([...behaviourFeedingProblem, "L"]);
                    break

                case "constipation":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['constipation']: true });
                    setBehaviourFeedingProblem([...behaviourFeedingProblem, "CS"]);
                    break

                default:
                    break;
            }

        } else {
            switch (name) {
                case "babbling":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['babbling']: false });
                    setBehaviourSpeech(prevValues => prevValues.filter(behaviourSpeech => behaviourSpeech !== "B"));
                    break;

                case "words":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['words']: false });
                    setBehaviourSpeech(prevValues => prevValues.filter(behaviourSpeech => behaviourSpeech !== "W"));
                    break;

                case "sentences":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['sentences']: false });
                    setBehaviourSpeech(prevValues => prevValues.filter(behaviourSpeech => behaviourSpeech !== "S"));
                    break;

                case "retarded":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['retarded']: false });
                    setBehaviourSpeech(prevValues => prevValues.filter(behaviourSpeech => behaviourSpeech !== "R"));
                    break;

                case "breast":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['breast']: false });
                    setBehaviourFeeding(prevValues => prevValues.filter(behaviourFeeding => behaviourFeeding !== "BR"));
                    break;

                case "top_dilution":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['top_dilution']: false });
                    setBehaviourFeeding(prevValues => prevValues.filter(behaviourFeeding => behaviourFeeding !== "T"));
                    break;

                case "bottle":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['bottle']: false });
                    setBehaviourFeeding(prevValues => prevValues.filter(behaviourFeeding => behaviourFeeding !== "BO"));
                    break;

                case "solids":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['solids']: false });
                    setBehaviourFeeding(prevValues => prevValues.filter(behaviourFeeding => behaviourFeeding !== "S"));
                    break;

                case "colic":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['colic']: false });
                    setBehaviourFeedingProblem(prevValues => prevValues.filter(behaviourFeedingProblem => behaviourFeedingProblem !== "CL"));
                    break;

                case "underfeeding":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['underfeeding']: false });
                    setBehaviourFeedingProblem(prevValues => prevValues.filter(behaviourFeedingProblem => behaviourFeedingProblem !== "U"));
                    break;

                case "overfeeding":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['overfeeding']: false });
                    setBehaviourFeedingProblem(prevValues => prevValues.filter(behaviourFeedingProblem => behaviourFeedingProblem !== "O"));
                    break;

                case "regurgitation":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['regurgitation']: false });
                    setBehaviourFeedingProblem(prevValues => prevValues.filter(behaviourFeedingProblem => behaviourFeedingProblem !== "R"));
                    break;

                case "loose_stools":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['loose_stools']: false });
                    setBehaviourFeedingProblem(prevValues => prevValues.filter(behaviourFeedingProblem => behaviourFeedingProblem !== "L"));
                    break;

                case "constipation":
                    setDevelopmentalBehaviour({ ...developmentalBehaviour, ['constipation']: false });
                    setBehaviourFeedingProblem(prevValues => prevValues.filter(behaviourFeedingProblem => behaviourFeedingProblem !== "CS"));
                    break;

                default:
                    break;
            }
        }
    }

    useEffect(() => {
        if (clinicBranchDetails.length === 1) {
            setPersonalInformation((prev) => ({
                ...prev,
                clinic_branch_id: clinicBranchDetails[0].clinic_branch_id
            }));
        }
    }, [clinicBranchDetails]);

    useEffect(() => {
        setChildProblems(childProblems => ({ ...childProblems, ['speech']: behaviourSpeech.join() }))
    }, [behaviourSpeech]);

    useEffect(() => {
        setChildProblems(childProblems => ({ ...childProblems, ['feeding']: behaviourFeeding.join() }))
    }, [behaviourFeeding]);

    useEffect(() => {
        setChildProblems(childProblems => ({ ...childProblems, ['feeding_problems']: behaviourFeedingProblem.join() }))
    }, [behaviourFeedingProblem]);

    useEffect(() => {
        if (params.patient_id) {
            if (pageLoading) {
                getPatientDetails()
            }
            setPageLoading(false);
        }

    }, [pageLoading, params.patient_id]);

    const getPatientDetails = (oEvent) => {
        setLoading(true);
        axiosInstance
            .get(`/patients/${params.patient_id}`)
            .then(response => {
                if (response.status === 200) {
                    setPatientIdForFile(response.data.personal_details.patient_id)
                    setPersonalInformation(response.data.personal_details)
                    setComplaintsChief(response.data.complaints_chief)
                    setComplaintsAssociated(response.data.complaints_associated)
                    setChiefComplaints(response.data.chief_complaints)
                    setAssociatedComplaints(response.data.associated_complaints)
                    setTotality(response.data.totality)
                    setOtherNotes(response.data.other_notes)
                    setFollowUpEvaluation(response.data.follow_up_evaluation)
                    setFollowUp(response.data.follow_up)
                    setPrevFollowUp(JSON.parse(JSON.stringify(response.data.follow_up)))
                    setPatientFiles(response.data.patient_files)
                    setDentalChart(response.data.dental_chart || {})
                    setPreviousDentalChart(response.data.previous_dental_charts || [])

                    if (response.data.physical_characteristics instanceof Array)
                        setPhysicalCharacteristics(response.data.physical_characteristics[0])
                    else
                        setPhysicalCharacteristics(response.data.physical_characteristics)

                    if (response.data.child_problems instanceof Array)
                        setChildProblems(response.data.child_problems[0])
                    else
                        setChildProblems(response.data.child_problems)

                    if (response.data.physical_examination instanceof Array)
                        setPhysicalExamination(response.data.physical_examination[0])
                    else
                        setPhysicalExamination(response.data.physical_examination)

                    if (response.data.diagnosis_remedy instanceof Array)
                        setDiagnosisRemedy(response.data.diagnosis_remedy[0])
                    else
                        setDiagnosisRemedy(response.data.diagnosis_remedy)

                    if (response.data.personal_details.marital_status === "M") {
                        setPatientMarried(true)
                    } else {
                        setPatientMarried(false)
                    }

                    if (Number(response.data.personal_details.age) < 18) {
                        setPatientAdult(false)
                    } else {
                        setPatientAdult(true)
                    }

                    if (Number(response.data.personal_details.age) <= 6) {
                        setDentalChartType('child')
                    } else if (Number(response.data.personal_details.age) > 6 && Number(response.data.personal_details.age) <= 12) {
                        setDentalChartType('teenage')
                    } else {
                        setDentalChartType('adult')
                    }

                    if (response.data.child_problems instanceof Array) {
                        setDevelopmentalBehaviour({
                            babbling: response.data.child_problems[0].speech.includes("B") ? true : false,
                            words: response.data.child_problems[0].speech.includes("W") ? true : false,
                            sentences: response.data.child_problems[0].speech.includes("S") ? true : false,
                            retarded: response.data.child_problems[0].speech.includes("R") ? true : false,
                            breast: response.data.child_problems[0].feeding.includes("BR") ? true : false,
                            top_dilution: response.data.child_problems[0].feeding.includes("T") ? true : false,
                            bottle: response.data.child_problems[0].feeding.includes("BO") ? true : false,
                            solids: response.data.child_problems[0].feeding.includes("S") ? true : false,
                            colic: response.data.child_problems[0].feeding_problems.includes("CL") ? true : false,
                            underfeeding: response.data.child_problems[0].feeding_problems.includes("U") ? true : false,
                            overfeeding: response.data.child_problems[0].feeding_problems.includes("O") ? true : false,
                            regurgitation: response.data.child_problems[0].feeding_problems.includes("R") ? true : false,
                            loose_stools: response.data.child_problems[0].feeding_problems.includes("L") ? true : false,
                            constipation: response.data.child_problems[0].feeding_problems.includes("CS") ? true : false,
                        })

                        if (response.data.child_problems[0].speech !== null) {
                            setBehaviourSpeech(response.data.child_problems[0].speech.split(","))
                        }
                        if (response.data.child_problems[0].feeding !== null) {
                            setBehaviourFeeding(response.data.child_problems[0].feeding.split(","))
                        }
                        if (response.data.child_problems[0].feeding_problems !== null) {
                            setBehaviourFeedingProblem(response.data.child_problems[0].feeding_problems.split(","))
                        }
                    } else {
                        if (response.data.child_problems.speech !== null) {
                            setBehaviourSpeech(response.data.child_problems?.speech?.split(",") || [])
                        }
                        if (response.data.child_problems.feeding !== null) {
                            setBehaviourFeeding(response.data.child_problems?.feeding?.split(",") || [])
                        }
                        if (response.data.child_problems.feeding_problems !== null) {
                            setBehaviourFeedingProblem(response.data.child_problems?.feeding_problems?.split(",") || [])
                        }
                    }

                    const remedyData = Array.isArray(response.data.diagnosis_remedy)
                        ? response.data.diagnosis_remedy[0]
                        : response.data.diagnosis_remedy;

                    const hasFollowUp = Array.isArray(response.data.follow_up) &&
                        response.data.follow_up.length > 0 && response.data.follow_up[0].follow_up_date !== undefined;
                    const remedyHasDateTime = remedyData?.next_appointment_date && remedyData?.next_appointment_time;
                    setIsNextAppointmentDisabled(hasFollowUp || remedyHasDateTime);
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 404) {
                    showToast("error", "Patient not found. Please try again.");
                } else {
                    showToast("error", "An error occurred while fetching patient details. Please try again.");
                }
                navigate("/patients", { replace: true });
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const onPressPrintPrescription = () => {
        const salutation = { '1': 'DR.', '2': 'MR.', '3': 'MRS.', '4': 'MISS', '5': 'MASTER' }
        const gender = { 'M': 'Male', 'F': "Female", 'O': "Others" }
        if (followUp[0].follow_up_date === undefined) {
            if (nextVisitPlan.next_appointment_date !== "" || nextVisitPlan.next_appointment_time !== "") {
                if (!nextVisitPlan.next_appointment_date) {
                    showToast("error", "Please enter next appointment date");
                    return;
                }
                if (new Date(nextVisitPlan.next_appointment_date) < new Date(diagnosisRemedy.next_appointment_date)) {
                    showToast("Next appointment date should be less than today's date");
                    return
                }
                if (new Date(nextVisitPlan.next_appointment_date) === new Date(diagnosisRemedy.next_appointment_date)) {
                    showToast("Next appointment date should not be the same as today's date");
                    return;
                }

                if (!nextVisitPlan.next_appointment_time) {
                    showToast("Please enter next appointment time");
                    return
                }
            }

            setPrescriptionDetails({
                patient_type: "NEW",
                patient_name: salutation[personalInformation.salutation] + " " + personalInformation.patient_name,
                patient_case_number: personalInformation.patient_case_number,
                age: personalInformation.age,
                gender: gender[personalInformation.gender],
                diagnosis_1: diagnosisRemedy.diagnosis_1,
                diagnosis_2: diagnosisRemedy.diagnosis_2,
                diagnosis_3: diagnosisRemedy.diagnosis_3,
                diagnosis_4: diagnosisRemedy.diagnosis_4,
                investigation: diagnosisRemedy.investigation,
                remedy: diagnosisRemedy.remedy,
                advice: diagnosisRemedy.advice,
                followUp: '',
                next_appointment_date: diagnosisRemedy.next_appointment_date,
                next_appointment_time: diagnosisRemedy.next_appointment_time,
                visit_date: currentDateFormat,
                user_type: userDetails.user_type,
                clinic_name: userDetails.clinic_name,
                doctor_name: userDetails.doctor_name,
                doctor_profession: userDetails.doctor_profession,
                registration_number: userDetails.registration_number,
                doctor_degree: userDetails.doctor_degree,
                doctor_mobile_number: userDetails.mobile_number,
                doctor_alternate_mobile_number: userDetails.alternate_mobile_number,
                doctor_email_id: userDetails.email_id,
                clinic_website: userDetails.clinic_website,
                clinic_address: userDetails.clinic_address,
            });
        } else {
            let next_follow_up = followUp[followUp.length - 1]
            if (!next_follow_up.next_appointment_date) {
                showToast("error", "Please enter next appointment date");
                return;
            }
            if (new Date(next_follow_up.next_appointment_date) < new Date(next_follow_up.follow_up_date)) {
                showToast("error", "Next appointment date should be less than follow up date");
                return;
            }
            if (new Date(next_follow_up.next_appointment_date).getTime() === new Date(next_follow_up.follow_up_date).getTime()) {
                showToast("error", "Next appointment date should not be same as follow up date");
                return;
            }
            if (!next_follow_up.next_appointment_time) {
                showToast("error", "Please enter next appointment time");
                return;
            }
            setPrescriptionDetails({
                patient_type: "FOLLOW-UP",
                patient_name: salutation[personalInformation.salutation] + " " + personalInformation.patient_name,
                patient_case_number: personalInformation.patient_case_number,
                age: personalInformation.age,
                gender: gender[personalInformation.gender],
                diagnosis_1: '',
                diagnosis_2: '',
                diagnosis_3: '',
                diagnosis_4: '',
                investigation: '',
                followUp: next_follow_up.follow_up === undefined ? '' : next_follow_up.follow_up,
                remedy: next_follow_up.remedy === undefined ? '' : next_follow_up.remedy,
                advice: next_follow_up.advice === undefined ? '' : next_follow_up.advice,
                next_appointment_date: next_follow_up.next_appointment_date,
                next_appointment_time: next_follow_up.next_appointment_time,
                visit_date: currentDateFormat,
                user_type: userDetails.user_type,
                clinic_name: userDetails.clinic_name,
                doctor_name: userDetails.doctor_name,
                doctor_profession: userDetails.doctor_profession,
                registration_number: userDetails.registration_number,
                doctor_degree: userDetails.doctor_degree,
                doctor_mobile_number: userDetails.mobile_number,
                doctor_alternate_mobile_number: userDetails.alternate_mobile_number,
                doctor_email_id: userDetails.email_id,
                clinic_website: userDetails.clinic_website,
                clinic_address: userDetails.clinic_address,
            });
        }
        setPrescriptionModalOpen(true);
    };

    /* Update Appointment Status */
    const onUpdateAppointmentStatus = (pType) => {
        if (appointmentDetails?.visitor_id) {
            let amount = '0';

            if (pType === "create") {
                amount = personalInformation.amount === undefined ? 0 : personalInformation.amount;
            } else {
                const isSameLength = followUp.length === prevFollowUp.length && prevFollowUp[0].follow_up_date !== undefined;
                const isSameData = isSameLength && isEqual(followUp, prevFollowUp);

                if (!isSameData) {
                    if (followUp.length > prevFollowUp.length) {
                        amount = followUp[followUp.length - 1].amount === undefined ? 0 : followUp[followUp.length - 1].amount;
                    }
                }
            }

            axiosInstance
                .put(`/appointments/${appointmentDetails.visitor_id}/`, {
                    status: "C",
                    amount: amount,
                })
                .then(response => { })
                .catch(error => { })
        }
    }

    /* Set Next Appointment for New Patient */
    const onNewPatientNextAppointment = (pNewPatientOrAppointmentDetails) => {
        if (nextVisitPlan.next_appointment_date !== "" && nextVisitPlan.next_appointment_time !== "") {
            let patientId = params.patient_id ? params.patient_id : pNewPatientOrAppointmentDetails?.patient_id;
            const newAppointmentDetailsState = {
                clinic_id: userDetails.clinic_id,
                clinic_branch_id: personalInformation.clinic_branch_id,
                slug: params.patient_id,
                salutation: personalInformation.salutation,
                visitor_name: personalInformation.patient_name,
                visitor_type: "E",
                patient_case_number: personalInformation.patient_case_number,
                accompanied_by: personalInformation.accompanied_by,
                referred_by: personalInformation.referred_by,
                age: personalInformation.age,
                gender: personalInformation.gender,
                marital_status: personalInformation.marital_status,
                married_since: personalInformation.married_since,
                name_of_parent_if_minor: personalInformation.name_of_parent_if_minor,
                mobile_number: personalInformation.mobile_number,
                email_id: personalInformation.email_id,
                patient_address: personalInformation.patient_address,
                patient_city: personalInformation.patient_city,
                appointment_date: nextVisitPlan.next_appointment_date,
                appointment_time: nextVisitPlan.next_appointment_time,
                patient_reference_id: patientId,
                status: "U",
            };

            axiosInstance
                .post("/appointments/", newAppointmentDetailsState)
                .then(response => { })
                .catch(error => { })
        }
    }

    /* Set Next Appointment for Follow Up Patient */
    const onFollowUpNextAppointment = () => {
        if (followUp[0].follow_up_date !== undefined) {
            const isSameLength = followUp.length === prevFollowUp.length && prevFollowUp[0].follow_up_date !== undefined;
            const isSameData = isSameLength && isEqual(followUp, prevFollowUp);

            if (!isSameData) {
                if (followUp[followUp.length - 1].follow_up_id === undefined) {
                    const newAppointmentDetailsState = {
                        clinic_id: userDetails.clinic_id,
                        clinic_branch_id: personalInformation.clinic_branch_id,
                        slug: params.patient_id,
                        salutation: personalInformation.salutation,
                        visitor_name: personalInformation.patient_name,
                        visitor_type: "E",
                        patient_case_number: personalInformation.patient_case_number,
                        accompanied_by: personalInformation.accompanied_by,
                        referred_by: personalInformation.referred_by,
                        age: personalInformation.age,
                        gender: personalInformation.gender,
                        marital_status: personalInformation.marital_status,
                        married_since: personalInformation.married_since,
                        name_of_parent_if_minor: personalInformation.name_of_parent_if_minor,
                        mobile_number: personalInformation.mobile_number,
                        email_id: personalInformation.email_id,
                        patient_address: personalInformation.patient_address,
                        patient_city: personalInformation.patient_city,
                        appointment_date: followUp[followUp.length - 1].next_appointment_date,
                        appointment_time: followUp[followUp.length - 1].next_appointment_time,
                        patient_reference_id: params.patient_id,
                        status: "U",
                    };

                    axiosInstance
                        .post("/appointments/", newAppointmentDetailsState)
                        .then(response => { })
                        .catch(error => { })
                }
            }
        }
    }

    /* Add new Patinet */
    const onPressSave = async (oEvent) => {
        oEvent.preventDefault();

        if (isSubmitting) return; // Prevent duplicate submissions

        setIsSubmitting(true);
        let fErrorStatus = []
        const aErrorMessage = ['visit_date', 'clinic_branch_id', 'salutation', 'patient_name', 'age', 'gender', 'mobile_number']
        fErrorStatus = fnFormValidation(personalInformation, personalInformationErrors, setPersonalInformationErrors, aErrorMessage)

        const aMobileNumberLengthCheck = ['mobile_number', 'alternate_mobile_number', 'spouse_mobile_number']
        fErrorStatus = fnMobileNumberValidation(personalInformation, personalInformationErrors, setPersonalInformationErrors, aMobileNumberLengthCheck, fErrorStatus)
        fErrorStatus = fnEmailValidation(personalInformation, personalInformationErrors, setPersonalInformationErrors, ['email_id'], fErrorStatus)

        if (followUp[0].follow_up_date !== undefined) {
            let next_follow_up = followUp[followUp.length - 1];

            if (!next_follow_up.next_appointment_date) {
                fErrorStatus.push("Please enter next appointment date");
            } else {
                if (new Date(next_follow_up.next_appointment_date) < new Date(next_follow_up.follow_up_date)) {
                    fErrorStatus.push("Next appointment date should be less than follow up date");
                }
                if (new Date(next_follow_up.next_appointment_date) === new Date(next_follow_up.follow_up_date)) {
                    fErrorStatus.push("Next appointment date should not be the same as follow up date");
                }
            }

            if (!next_follow_up.next_appointment_time) {
                fErrorStatus.push("Please enter next appointment time");
            }
        }

        if (nextVisitPlan.next_appointment_date !== "" || nextVisitPlan.next_appointment_time !== "") {
            if (new Date(nextVisitPlan.next_appointment_date) < new Date(diagnosisRemedy.next_appointment_date)) {
                fErrorStatus.push("Next appointment date should be less than today's date");
            }
            if (new Date(nextVisitPlan.next_appointment_date) === new Date(diagnosisRemedy.next_appointment_date)) {
                fErrorStatus.push("Next appointment date should not be the same as today's date");
            }

            if (!nextVisitPlan.next_appointment_time) {
                fErrorStatus.push("Please enter next appointment time");
            }
        }

        if (fErrorStatus.length === 0) {
            let oPatientDetails = {
                "personal_details": personalInformation,
                "complaints_chief": complaintsChief,
                "complaints_associated": complaintsAssociated,
                "chief_complaints": chiefComplaints,
                "associated_complaints": associatedComplaints,
                "physical_characteristics": physicalCharacteristics,
                "child_problems": childProblems,
                "physical_examination": physicalExamination,
                "dental_chart": dentalChart,
                "previous_dental_charts": previousDentalChart,
                "totality": totality,
                "diagnosis_remedy": diagnosisRemedy,
                "other_notes": otherNotes,
                "follow_up_evaluation": followUpEvaluation,
                "follow_up": followUp
            }

            oPatientDetails = JSON.parse(JSON.stringify(oPatientDetails))
            if (params.patient_id) {
                setLoading(true);
                axiosInstance
                    .put(`/patients/${params.patient_id}/`, oPatientDetails)
                    .then(response => {
                        if (response.status === 200) {
                            if (appointmentDetails?.visitor_id)
                                onUpdateAppointmentStatus("update")

                            if (followUp[0].follow_up_date !== undefined)
                                onFollowUpNextAppointment()

                            if (!isNextAppointmentDisabled && (nextVisitPlan.next_appointment_date !== "" || nextVisitPlan.next_appointment_time !== ""))
                                onNewPatientNextAppointment()

                            setIsPatientSaved(true);
                            showToast("success", response.data.message);
                            // setTimeout(() => navigate("/appointment", { replace: true }), 2000); // same as toast duration
                        } else if (response.status === 403) {
                            showToast("error", "You cannot update patient details as your clinic plan has expired. Please renew your plan to manage patients.");
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 403 && error.response.data.detail === "Your clinic plan has expired.") {
                            showToast("error", "You cannot add new patient details as your clinic plan has expired. Please renew your plan to manage patients.");
                        } else if (error.response && error.response.data) {
                            let data = error.response.data;

                            // 🟢 Case 1: Stringified error (e.g., "{'patient_case_number': [ErrorDetail(string='...', code='invalid')]}").
                            if (typeof data === "string" || (data.error && typeof data.error === "string")) {
                                let raw = typeof data === "string" ? data : data.error;
                                try {
                                    // Clean up Django's ErrorDetail representation
                                    const cleaned = raw
                                        .replace(/ErrorDetail\(string='(.*?)', code='.*?'\)/g, '"$1"')
                                        .replace(/'/g, '"');

                                    data = JSON.parse(cleaned);
                                } catch (e) {
                                    showToast("error", raw); // fallback
                                    return;
                                }
                            }

                            // 🟢 Case 2: Standard DRF error object
                            if (typeof data === "object" && !Array.isArray(data)) {
                                Object.entries(data).forEach(([key, messages]) => {
                                    const msgs = Array.isArray(messages) ? messages : [messages];

                                    if (key === "non_field_errors") {
                                        msgs.forEach((msg) => showToast("error", msg));
                                    } else {
                                        msgs.forEach((msg) => {
                                            let errorMessage = msg;

                                            if (typeof errorMessage === "string" && errorMessage.includes("personal_ details with this employee Name already exists.")) {
                                                errorMessage = errorMessage.slice(28);
                                            }

                                            showToast("error", `${errorMessage}`);
                                        });
                                    }
                                });
                            }
                        } else {
                            showToast("error", "An unexpected error occurred.");
                        }
                    })
                    .finally(() => {
                        setIsSubmitting(false);
                        setLoading(false);
                    });
            } else {
                setLoading(true);
                axiosInstance
                    .post("/patients/", oPatientDetails)
                    .then(response => {
                        if (response.status === 201) {
                            setPatientIdForFile(response.data.data.patient_id)
                            setPersonalInformation((prev) => ({
                                ...prev,
                                patient_case_number: response.data.data.patient_case_number
                            }));
                            if (appointmentDetails?.visitor_id)
                                onUpdateAppointmentStatus("create")

                            if (followUp[0].follow_up_date !== undefined)
                                onFollowUpNextAppointment()

                            if (!isNextAppointmentDisabled && (nextVisitPlan.next_appointment_date !== "" || nextVisitPlan.next_appointment_time !== ""))
                                onNewPatientNextAppointment(response.data.data)

                            setIsPatientSaved(true);
                            showToast("success", response.data.message);
                            // setTimeout(() => navigate("/appointment", { replace: true }), 2000); // same as toast duration
                        } else if (response.status === 403) {
                            showToast("error", "You cannot add new patient details as your clinic plan has expired. Please renew your plan to manage patients.");
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 403 && error.response.data.detail === "Your clinic plan has expired.") {
                            showToast("error", "You cannot add new patient details as your clinic plan has expired. Please renew your plan to manage patients.");
                        } else if (error.response && error.response.data) {
                            let data = error.response.data;

                            // 🟢 Case 1: Stringified error (e.g., "{'patient_case_number': [ErrorDetail(string='...', code='invalid')]}").
                            if (typeof data === "string" || (data.error && typeof data.error === "string")) {
                                let raw = typeof data === "string" ? data : data.error;
                                try {
                                    // Clean up Django's ErrorDetail representation
                                    const cleaned = raw
                                        .replace(/ErrorDetail\(string='(.*?)', code='.*?'\)/g, '"$1"')
                                        .replace(/'/g, '"');

                                    data = JSON.parse(cleaned);
                                } catch (e) {
                                    showToast("error", raw); // fallback
                                    return;
                                }
                            }

                            // 🟢 Case 2: Standard DRF error object
                            if (typeof data === "object" && !Array.isArray(data)) {
                                Object.entries(data).forEach(([key, messages]) => {
                                    const msgs = Array.isArray(messages) ? messages : [messages];

                                    if (key === "non_field_errors") {
                                        msgs.forEach((msg) => showToast("error", msg));
                                    } else {
                                        msgs.forEach((msg) => {
                                            let errorMessage = msg;

                                            if (typeof errorMessage === "string" && errorMessage.includes("personal_ details with this employee Name already exists.")) {
                                                errorMessage = errorMessage.slice(28);
                                            }

                                            showToast("error", `${errorMessage}`);
                                        });
                                    }
                                });
                            }
                        } else {
                            showToast("error", "An unexpected error occurred.");
                        }
                    })
                    .finally(() => {
                        setIsSubmitting(false);
                        setLoading(false);
                    });
            }
        } else {
            fErrorStatus.forEach((error) => {
                showToast("error", error, { toastId: error });
            });
            setIsSubmitting(false);
        }
    }

    /* Open Modal for ICD Code */
    const onPressOpenICD = (oEvent, pDiagnosisId) => {
        oEvent.preventDefault();
        setIsModalOpen({ ['isModalOpen_diagnosis_' + pDiagnosisId]: true })
    }

    /* Navigate to home screen */
    const onPressCancel = (oEvent) => {
        oEvent.preventDefault();
        navigate(-1)
    }

    /* File Upload Start */
    const onFileChange = (oEvent) => {
        const file = oEvent.target.files[0];

        // Allowed MIME types
        const allowedTypes = [
            // Images
            'image/png',
            'image/jpeg',
            'image/jpg',

            // PDF
            'application/pdf',

            // Word
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

            // Excel
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];

        if (file && !allowedTypes.includes(file.type)) {
            showToast('error', 'Invalid file type. Only JPG, PNG, PDF, Word, Excel files are allowed.');
            oEvent.target.value = '';
            return;
        }

        setFormFile({ ...formFile, file_url: file });
    };

    const onFileUpload = async () => {
        if (!patientIdForFile) {
            showToast("error", "Please save the patient details before uploading files.");
            return;
        }

        const formData = new FormData();
        formData.append('file_url', formFile.file_url);
        formData.append('file_name', formFile.file_name);
        formData.append('upload_date', formFile.upload_date);
        formData.append('remark', formFile.remark);
        formData.append('pk', params.patient_id);

        try {
            setLoading(true);
            const response = await axiosInstance.post('/patient-file/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.status === 201) {
                showToast("success", response.data.message);
                setPatientFiles([...patientFiles, response.data.data]);
                setFormFile({
                    file_url: null,
                    file_name: '',
                    upload_date: currentDateFormat,
                    remark: ''
                });

                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            } else if (response.status === 403 && response.data.detail === "Your clinic plan has expired.") {
                showToast("error", "You cannot upload file as your clinic plan has expired. Please renew your plan to manage patients.");
            }
        } catch (error) {
            if (error.response && error.response.status === 403 && error.response.data.detail === "Your clinic plan has expired.") {
                showToast("error", "You cannot upload file as your clinic plan has expired. Please renew your plan to manage patients.");
            } else {
                if (error.response && error.response.data) {
                    Object.entries(error.response.data).forEach(([key, messages]) => {
                        let formattedKey = key
                            .replaceAll("_", " ")
                            .replace(/([A-Z])/g, " $1")
                            .replace(/^\w/, (c) => c.toUpperCase()); // Capitalize first letter

                        let errorMessage = messages[0];
                        showToast("error", `${formattedKey} | ${errorMessage}`);
                    });
                } else {
                    showToast("error", "Failed to upload file. Please try again.");
                }
            }
        } finally {
            setLoading(false);
        }
    }

    const onPressDeleteFile = (oEvent, pFileId) => {
        oEvent.preventDefault();
        setIsDeleteFileModalOpen({ ['isDeleteFileModalOpen_' + pFileId]: true })
    }

    const onPressSubmitDeleteFile = async (oEvent, pFileId) => {
        oEvent.preventDefault();
        try {
            setLoading(true);
            const response = await axiosInstance.delete(`/patient-file/${pFileId}/`);

            if (response.status === 200) {
                showToast("success", "File deleted successfully.");
                setPatientFiles(patientFiles.filter(file => file.file_id !== pFileId));
                setIsDeleteFileModalOpen({ ['isDeleteFileModalOpen_' + pFileId]: false });
            }
        } catch (error) {
            showToast("error", "Failed to delete file. Please try again.");
        } finally {
            setLoading(false);
        }
    }
    /* File Upload End */

    return (
        <>
            <Tab.Container defaultActiveKey="#personal-info">
                <Row>
                    <div className={`sidebar-wrapper ${isSidebarCollapsed ? "collapsed" : ""}`}>
                        <ListGroup variant="flush" className="patient-sidebar">
                            {/* Collapse Button as ListGroup Item */}
                            <ListGroup.Item
                                action
                                onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                                className="d-flex align-items-center collapse-toggle-btn"
                            >
                                <span className="icon me-2 d-flex justify-content-center"><Menu size={18} /></span>
                                {!isSidebarCollapsed && <span className="label">Collapse</span>}
                            </ListGroup.Item>

                            {menuItems.map((item, idx) =>
                                item.hide ? null : (
                                    <OverlayTrigger
                                        key={idx}
                                        placement="right"
                                        overlay={
                                            isSidebarCollapsed ? (
                                                <Tooltip id={`tooltip-${item.key}`}>{item.label}</Tooltip>
                                            ) : <></>
                                        }
                                    >
                                        <ListGroup.Item
                                            href={item.key}
                                            onClick={(e) => e.preventDefault()}
                                            className="d-flex align-items-center"
                                        >
                                            <span className="icon me-2 d-flex justify-content-center">{item.icon}</span>
                                            {!isSidebarCollapsed && <span className="label">{item.label}</span>}
                                        </ListGroup.Item>
                                    </OverlayTrigger>
                                )
                            )}
                        </ListGroup>
                    </div>

                    {/* Main Content */}
                    <div className={`main-content ${isSidebarCollapsed ? "expanded" : "contracted"}`}>
                        <Form autoComplete="off" noValidate>
                            <Tab.Content>
                                <Tab.Pane eventKey="#personal-info" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Personal Information</Accordion.Header>
                                            <Accordion.Body>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} md={6} controlId="formVisitDate">
                                                        <Form.Label className="required">Visit Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="visit_date"
                                                            value={personalInformation.visit_date || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.visit_date}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.visit_date}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group as={Col} md={3} controlId="formAmount">
                                                        <Form.Label>Amount</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="amount"
                                                            placeholder='Amount'
                                                            value={personalInformation.amount || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.amount}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.amount}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group as={Col} md={3} controlId="formAmountPaidVia">
                                                        <Form.Label>Amount Paid Via</Form.Label>
                                                        <Form.Control
                                                            as={FormSelect}
                                                            name="amount_paid_via"
                                                            value={personalInformation.amount_paid_via || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.amount_paid_via}
                                                        >
                                                            <option value="">Select Payment Method</option>
                                                            <option value="cash">Cash</option>
                                                            <option value="card">Card</option>
                                                            <option value="upi">UPI</option>
                                                            <option value="other">Other</option>
                                                        </Form.Control>
                                                        <Form.Control.Feedback type="invalid">
                                                            {personalInformationErrors.amount_paid_via}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formClinicBranchId">
                                                        <Form.Label className="required">Clinic Branch</Form.Label>
                                                        <Form.Control
                                                            as={FormSelect}
                                                            name="clinic_branch_id"
                                                            value={personalInformation.clinic_branch_id || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.clinic_branch_id}>
                                                            <option value="">Select Clinic Branch</option>
                                                            {clinicBranchDetails.map((branch) => (
                                                                <option key={branch.clinic_branch_id} value={branch.clinic_branch_id}>
                                                                    {branch.branch_address}
                                                                </option>
                                                            ))}
                                                        </Form.Control>
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.clinic_branch_id}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formPatientCaseNumber">
                                                        <Form.Label>Patient Case Number</Form.Label>
                                                        <Form.Control
                                                            disabled
                                                            type="text"
                                                            name="patient_case_number"
                                                            placeholder='Patient Case Number'
                                                            value={personalInformation.patient_case_number || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.patient_case_number}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.patient_case_number}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Form.Group as={Col} sm={3} controlId="formSalutation">
                                                        <Form.Label className="required">Salutation</Form.Label>
                                                        <Form.Control
                                                            as={FormSelect}
                                                            name="salutation"
                                                            value={personalInformation.salutation || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.salutation}>
                                                            <option value="">Select Salutation</option>
                                                            <option value="1">DR.</option>
                                                            <option value="2">MR.</option>
                                                            <option value="3">MRS.</option>
                                                            <option value="4">MISS</option>
                                                            <option value="5">MASTER</option>
                                                        </Form.Control>
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formPatientName">
                                                        <Form.Label className="required">Patient Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="patient_name"
                                                            placeholder='Patient Name'
                                                            value={personalInformation.patient_name || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.patient_name}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.patient_name}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formAccompaniedBy">
                                                        <Form.Label>Accompanied By</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="accompanied_by"
                                                            placeholder='Accompanied By'
                                                            value={personalInformation.accompanied_by || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.accompanied_by}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.accompanied_by}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formReferredBy">
                                                        <Form.Label>Referred By</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="referred_by"
                                                            placeholder='Referred By'
                                                            value={personalInformation.referred_by || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.referred_by}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.referred_by}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formAge">
                                                        <Form.Label className="required">Age</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="age"
                                                            placeholder='Age'
                                                            value={personalInformation.age}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            onBlur={(oEvent) => onFocusOut(oEvent, personalInformation, setPersonalInformation)}
                                                            onWheel={(e) => e.target.blur()}
                                                            isInvalid={personalInformationErrors.age}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.age}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formGender">
                                                        <Form.Label className="required">Gender</Form.Label>
                                                        <Form.Control
                                                            as={FormSelect}
                                                            name="gender"
                                                            value={personalInformation.gender || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.gender}>
                                                            <option value="">Select Gender</option>
                                                            <option value="M">Male</option>
                                                            <option value="F">Female</option>
                                                            <option value="O">Other</option>
                                                        </Form.Control>
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.gender}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formMaritalStatus">
                                                        <Form.Label>Marital Status</Form.Label>
                                                        <Form.Control
                                                            as={FormSelect}
                                                            name="marital_status"
                                                            value={personalInformation.marital_status || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.marital_status}>
                                                            <option value="">Select Marital Status</option>
                                                            <option value="UM">Unmarried</option>
                                                            <option value="DP">Domestic Partnership</option>
                                                            <option value="M">Married</option>
                                                            <option value="SE">Separated</option>
                                                            <option value="DI">Divorced</option>
                                                            <option value="WI">Widowed</option>
                                                        </Form.Control>
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.marital_status}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group as={Col} className={isPatientMarried ? "" : "d-none"} controlId="formMarriedSince">
                                                        <Form.Label>Married Since</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="married_since"
                                                            placeholder='Married Since'
                                                            value={personalInformation.married_since}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            onWheel={(e) => e.target.blur()}
                                                            isInvalid={personalInformationErrors.married_since}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.married_since}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>

                                                <Form.Group className={isPatientAdult ? "d-none" : "mb-3"} controlId="formNameOfParent">
                                                    <Form.Label>Name of Parent if patient is minor</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="name_of_parent_if_minor"
                                                        placeholder='Name of Parent if patient is minor'
                                                        value={personalInformation.name_of_parent_if_minor || ""}
                                                        onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                        isInvalid={personalInformationErrors.name_of_parent_if_minor}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{personalInformationErrors.name_of_parent_if_minor}</Form.Control.Feedback>
                                                </Form.Group>

                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formMobileNumber">
                                                        <Form.Label className="required">Mobile Number</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="mobile_number"
                                                            placeholder='Mobile Number'
                                                            value={personalInformation.mobile_number || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.mobile_number}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.mobile_number}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formAlternateMobileNumber">
                                                        <Form.Label>Alternate Mobile Number</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="alternate_mobile_number"
                                                            placeholder='Alternate Mobile Number'
                                                            value={personalInformation.alternate_mobile_number || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.alternate_mobile_number}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.alternate_mobile_number}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formEmailID">
                                                        <Form.Label>Email ID</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="email_id"
                                                            placeholder='Email ID'
                                                            value={personalInformation.email_id || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.email_id}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.email_id}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group as={Col} scontrolId="formBloodGroup">
                                                        <Form.Label>Blood Group</Form.Label>
                                                        <Form.Control
                                                            as={FormSelect}
                                                            name="blood_group"
                                                            value={personalInformation.blood_group || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.blood_group}>
                                                            <option value="">Select Blood Group</option>
                                                            <option value="A+">A+ve</option>
                                                            <option value="A-">A-ve</option>
                                                            <option value="AB+">AB+ve</option>
                                                            <option value="AB-">AB-ve</option>
                                                            <option value="B+">B+ve</option>
                                                            <option value="B-">B-ve</option>
                                                            <option value="O+">O+ve</option>
                                                            <option value="O-">O-ve</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Row>

                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formEducation">
                                                        <Form.Label>Education</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="education"
                                                            placeholder='Education'
                                                            value={personalInformation.education || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.education}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.education}</Form.Control.Feedback>
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formOccupation">
                                                        <Form.Label>Occupation</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="occupation"
                                                            placeholder='Occupation'
                                                            value={personalInformation.occupation || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.occupation}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.occupation}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1" className={isPatientMarried ? "mt-3" : "d-none mt-3"}>
                                            <Accordion.Header>Spouse Details</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group className="mb-3" controlId="formSpouseName">
                                                    <Form.Label>Spouse Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="spouse_name"
                                                        placeholder='Spouse Name'
                                                        value={personalInformation.spouse_name || ""}
                                                        onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                        isInvalid={personalInformationErrors.spouse_name}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{personalInformationErrors.spouse_name}</Form.Control.Feedback>
                                                </Form.Group>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formSpouseAge">
                                                        <Form.Label>Age</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="spouse_age"
                                                            placeholder='Age'
                                                            value={personalInformation.spouse_age}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            onWheel={(e) => e.target.blur()}
                                                            isInvalid={personalInformationErrors.spouse_age}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.spouse_age}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formSpouseMobileNumber">
                                                        <Form.Label>Mobile Number</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="spouse_mobile_number"
                                                            placeholder='Mobile Number'
                                                            value={personalInformation.spouse_mobile_number || ""}
                                                            onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                            isInvalid={personalInformationErrors.spouse_mobile_number}
                                                        />
                                                        <Form.Control.Feedback type="invalid">{personalInformationErrors.spouse_mobile_number}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                                <Form.Group className="mb-3" controlId="formSpouseOccupation">
                                                    <Form.Label>Occupation</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="spouse_occupation"
                                                        placeholder='Occupation'
                                                        value={personalInformation.spouse_occupation || ""}
                                                        onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                        isInvalid={personalInformationErrors.spouse_occupation}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{personalInformationErrors.spouse_occupation}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2" className="mt-3">
                                            <Accordion.Header>Family History</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group controlId="formFamilyHistory">
                                                    <Form.Control as="textarea" rows={9}
                                                        name="family_history"
                                                        placeholder='Family History'
                                                        value={personalInformation.family_history || ""}
                                                        onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                        isInvalid={personalInformationErrors.family_history}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{personalInformationErrors.family_history}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="3" className="mt-3">
                                            <Accordion.Header>Past History</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group controlId="formPastHistory">
                                                    <Form.Control as="textarea" rows={9}
                                                        name="past_history"
                                                        placeholder='Past History / Allergies'
                                                        value={personalInformation.past_history || ""}
                                                        onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                        isInvalid={personalInformationErrors.past_history}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{personalInformationErrors.past_history}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="4" className="mt-3">
                                            <Accordion.Header>Address</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group className="mb-3" controlId="formPatientAddress">
                                                    <Form.Control as="textarea" rows={9}
                                                        name="patient_address"
                                                        placeholder='Address'
                                                        value={personalInformation.patient_address || ""}
                                                        onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                        isInvalid={personalInformationErrors.patient_address}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{personalInformationErrors.patient_address}</Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group controlId="formPatientCity">
                                                    <Form.Control
                                                        type="text"
                                                        name="patient_city"
                                                        placeholder='City'
                                                        value={personalInformation.patient_city || ""}
                                                        onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                        isInvalid={personalInformationErrors.patient_city}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{personalInformationErrors.patient_city}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#complaints" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Chief Complaints</Accordion.Header>
                                            <Accordion.Body>
                                                <Button variant="outline-secondary" className='mb-3' onClick={() => onPressTableRowAdd('complaintsChief')}>
                                                    Add Row
                                                </Button>

                                                <Table bordered hover responsive>
                                                    <tbody>
                                                        {complaintsChief.map((item, index) => {
                                                            return [
                                                                <tr key={['complaints_chief', '-', index].join()} className="mb-3">
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={1}
                                                                            name="complaints_chief"
                                                                            value={item.complaints_chief || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.complaints_chief = oEvent.target.value;
                                                                                setComplaintsChief([...complaintsChief]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ]
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1" className="mt-3">
                                            <Accordion.Header>Associated Complaints</Accordion.Header>
                                            <Accordion.Body>
                                                <Button variant="outline-secondary" className='mb-3' onClick={() => onPressTableRowAdd('complaintsAssociated')}>
                                                    Add Row
                                                </Button>

                                                <Table bordered hover responsive>
                                                    <tbody>
                                                        {complaintsAssociated.map((item, index) => {
                                                            return [
                                                                <tr key={['complaints_associated', '-', index].join()} className="mb-3">
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={1}
                                                                            name="complaints_associated"
                                                                            value={item.complaints_associated || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.complaints_associated = oEvent.target.value;
                                                                                setComplaintsAssociated([...complaintsAssociated]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ]
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#present-history" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Chief Complaint(s)</Accordion.Header>
                                            <Accordion.Body>
                                                <Button variant="outline-secondary" className='mb-3' onClick={() => onPressTableRowAdd('chiefComplaints')}>
                                                    Add Row
                                                </Button>

                                                <Table bordered hover responsive>
                                                    <thead light="true">
                                                        <tr>
                                                            <th style={{ width: "3rem", verticalAlign: 'text-top' }}>#</th>
                                                            <th style={{ textAlign: 'center' }}>Location</th>
                                                            <th style={{ textAlign: 'center' }}>Sensation Pathology</th>
                                                            <th style={{ textAlign: 'center' }}>Modalities</th>
                                                            <th style={{ textAlign: 'center' }}>Accompaniments</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {chiefComplaints.map((item, index) => {
                                                            return [
                                                                <tr key={['chief', '-', index].join()} className="mb-3">
                                                                    <td>{index + 1}</td>
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={3}
                                                                            name="location"
                                                                            value={item.location || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.location = oEvent.target.value;
                                                                                setChiefComplaints([...chiefComplaints]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={3}
                                                                            name="sensation_pathology"
                                                                            value={item.sensation_pathology || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.sensation_pathology = oEvent.target.value;
                                                                                setChiefComplaints([...chiefComplaints]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={3}
                                                                            name="modalities"
                                                                            value={item.modalities || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.modalities = oEvent.target.value;
                                                                                setChiefComplaints([...chiefComplaints]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={3}
                                                                            name="accompaniments"
                                                                            value={item.accompaniments || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.accompaniments = oEvent.target.value;
                                                                                setChiefComplaints([...chiefComplaints]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ]
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1" className="mt-3">
                                            <Accordion.Header>Associated Complaints (Concomitants)</Accordion.Header>
                                            <Accordion.Body>
                                                <Button variant="outline-secondary" className='mb-3' onClick={() => onPressTableRowAdd('associatedComplaints')}>
                                                    Add Row
                                                </Button>

                                                <Table bordered hover responsive>
                                                    <thead light="true">
                                                        <tr>
                                                            <th style={{ width: "3rem", verticalAlign: 'text-top' }}>#</th>
                                                            <th style={{ textAlign: 'center' }}>Location</th>
                                                            <th style={{ textAlign: 'center' }}>Sensation Pathology</th>
                                                            <th style={{ textAlign: 'center' }}>Modalities</th>
                                                            <th style={{ textAlign: 'center' }}>Accompaniments</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {associatedComplaints.map((item, index) => {
                                                            return [
                                                                <tr key={['associated', '-', index].join()} className="mb-3">
                                                                    <td>{index + 1}</td>
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={3}
                                                                            name="location"
                                                                            value={item.location || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.location = oEvent.target.value;
                                                                                setAssociatedComplaints([...associatedComplaints]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={3}
                                                                            name="sensation_pathology"
                                                                            value={item.sensation_pathology || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.sensation_pathology = oEvent.target.value;
                                                                                setAssociatedComplaints([...associatedComplaints]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={3}
                                                                            name="modalities"
                                                                            value={item.modalities || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.modalities = oEvent.target.value;
                                                                                setAssociatedComplaints([...associatedComplaints]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={3}
                                                                            name="accompaniments"
                                                                            value={item.accompaniments || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.accompaniments = oEvent.target.value;
                                                                                setAssociatedComplaints([...associatedComplaints]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ]
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#physical-char" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Physical Characteristics</Accordion.Header>
                                            <Accordion.Body>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formAppearance">
                                                        <Form.Label>Appearance</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="appearance"
                                                            placeholder='Appearance'
                                                            value={physicalCharacteristics.appearance || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formPerspiration">
                                                        <Form.Label>Perspiration</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="perspiration"
                                                            placeholder='Perspiration'
                                                            value={physicalCharacteristics.perspiration || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formHunger">
                                                        <Form.Label>Hunger</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="hunger"
                                                            placeholder='Hunger'
                                                            value={physicalCharacteristics.hunger || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formAppetite">
                                                        <Form.Label>Appetite</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="appetite"
                                                            placeholder='Appetite'
                                                            value={physicalCharacteristics.appetite || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formThirst">
                                                        <Form.Label>Thirst</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="thirst"
                                                            placeholder='Thirst'
                                                            value={physicalCharacteristics.thirst || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formCravings">
                                                        <Form.Label>Cravings</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="cravings"
                                                            placeholder='Cravings'
                                                            value={physicalCharacteristics.cravings || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formAversions">
                                                        <Form.Label>Aversions</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="aversions"
                                                            placeholder='Aversions'
                                                            value={physicalCharacteristics.aversions || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formDisagree">
                                                        <Form.Label>Disagree</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="disagree"
                                                            placeholder='Disagree'
                                                            value={physicalCharacteristics.disagree || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formThermal">
                                                        <Form.Label>Thermal</Form.Label>
                                                        <Form.Control
                                                            as={FormSelect}
                                                            name="thermal"
                                                            value={physicalCharacteristics.thermal || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}>
                                                            <option value="">Select Thermal</option>
                                                            <option value="H">Hot</option>
                                                            <option value="C">Chilly</option>
                                                            <option value="A">Ambi-Thermal</option>
                                                        </Form.Control>
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formStool">
                                                        <Form.Label>Stool</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="stool"
                                                            placeholder='Stool'
                                                            value={physicalCharacteristics.stool || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formUrine">
                                                        <Form.Label>Urine</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="urine"
                                                            placeholder='Urine'
                                                            value={physicalCharacteristics.urine || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formMenstrualFunction">
                                                        <Form.Label>Menstrual Function</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="menstrual_function"
                                                            placeholder='Menstrual Function'
                                                            value={physicalCharacteristics.menstrual_function || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formSexualFunction">
                                                        <Form.Label>Sexual Function</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="sexual_function"
                                                            placeholder='Sexual Function'
                                                            value={physicalCharacteristics.sexual_function || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formSensorySensitivity">
                                                        <Form.Label>Sensory Sensitivity</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="sensory_sensitivity"
                                                            placeholder='Sensory Sensitivity'
                                                            value={physicalCharacteristics.sensory_sensitivity || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formSleep">
                                                        <Form.Label>Sleep</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="sleep"
                                                            placeholder='Sleep'
                                                            value={physicalCharacteristics.sleep || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formDreams">
                                                        <Form.Label>Dreams</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="dreams"
                                                            placeholder='Dreams'
                                                            value={physicalCharacteristics.dreams || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formHobbies">
                                                        <Form.Label>Hobbies</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="hobbies"
                                                            placeholder='Hobbies'
                                                            value={physicalCharacteristics.hobbies || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formAddictions">
                                                        <Form.Label>Addictions</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="addictions"
                                                            placeholder='Addictions'
                                                            value={physicalCharacteristics.addictions || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalCharacteristics, setPhysicalCharacteristics)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#life-space" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Childhood</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group controlId="formChildhood">
                                                    <Form.Control as="textarea" rows={9}
                                                        name="life_space_childhood"
                                                        placeholder='Childhood'
                                                        value={personalInformation.life_space_childhood || ""}
                                                        onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                        isInvalid={personalInformationErrors.life_space_childhood}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{personalInformationErrors.life_space_childhood}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1" className="mt-3">
                                            <Accordion.Header>Adulthood</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group controlId="formAdulthood">
                                                    <Form.Control as="textarea" rows={9}
                                                        name="life_space_adulthood"
                                                        placeholder='Adulthood'
                                                        value={personalInformation.life_space_adulthood || ""}
                                                        onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                        isInvalid={personalInformationErrors.life_space_adulthood}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{personalInformationErrors.life_space_adulthood}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2" className="mt-3">
                                            <Accordion.Header>Old Age</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group controlId="formOldAge">
                                                    <Form.Control as="textarea" rows={9}
                                                        name="life_space_old_age"
                                                        placeholder='Old Age'
                                                        value={personalInformation.life_space_old_age || ""}
                                                        onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                        isInvalid={personalInformationErrors.life_space_old_age}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{personalInformationErrors.life_space_old_age}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="3" className="mt-3">
                                            <Accordion.Header>Interpersonal Relationships</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group controlId="formInterpersonal">
                                                    <Form.Control as="textarea" rows={9}
                                                        name="life_space_interpersonal"
                                                        placeholder='Interpersonal Relationships'
                                                        value={personalInformation.life_space_interpersonal || ""}
                                                        onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                        isInvalid={personalInformationErrors.life_space_interpersonal}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{personalInformationErrors.life_space_interpersonal}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="4" className="mt-3">
                                            <Accordion.Header>Other Notes</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group controlId="formLifeOtherNotes">
                                                    <Form.Control as="textarea" rows={9}
                                                        name="life_space_other_notes"
                                                        placeholder='Other Notes'
                                                        value={personalInformation.life_space_other_notes || ""}
                                                        onChange={(oEvent) => onChange(oEvent, personalInformation, setPersonalInformation, personalInformationErrors, setPersonalInformationErrors)}
                                                        isInvalid={personalInformationErrors.life_space_other_notes}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{personalInformationErrors.life_space_other_notes}</Form.Control.Feedback>
                                                </Form.Group>

                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#child-problem" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Problems</Accordion.Header>
                                            <Accordion.Body>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formPhysicalDevelopment">
                                                        <Form.Label>Physical Development</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="physical_development"
                                                            placeholder='Physical Development'
                                                            value={childProblems.physical_development || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formHead">
                                                        <Form.Label>Head</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="head"
                                                            placeholder='Head'
                                                            value={childProblems.head || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formMentalDevelopment">
                                                        <Form.Label>Mental Development</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="mental_development"
                                                            placeholder='Mental Development'
                                                            value={childProblems.mental_development || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formAbdomen">
                                                        <Form.Label>Abdomen</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="abdomen"
                                                            placeholder='Abdomen'
                                                            value={childProblems.abdomen || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formRecognitionObjects">
                                                        <Form.Label>Recognition Objects / Persons</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="recognition_objects"
                                                            placeholder='Recognition Objects / Persons'
                                                            value={childProblems.recognition_objects || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formFontanellae">
                                                        <Form.Label>Fontanellae (Closure)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="fontanellae"
                                                            placeholder='Fontanellae (Closure)'
                                                            value={childProblems.fontanellae || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formSocialSmile" className="col-6">
                                                        <Form.Label>Social Smile</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="social_smile"
                                                            placeholder='Social Smile'
                                                            value={childProblems.social_smile || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1" className="mt-3">
                                            <Accordion.Header>Dentition</Accordion.Header>
                                            <Accordion.Body>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formHeadHolding">
                                                        <Form.Label>Head Holding</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="head_holding"
                                                            placeholder='Head Holding'
                                                            value={childProblems.head_holding || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formObjectGrasp">
                                                        <Form.Label>Object Grasp</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="object_grasp"
                                                            placeholder='Object Grasp'
                                                            value={childProblems.object_grasp || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formTurningPrine">
                                                        <Form.Label>Turning Prine</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="turning_prine"
                                                            placeholder='Turning Prine'
                                                            value={childProblems.turning_prine || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formHandTransfer">
                                                        <Form.Label>Hand-To-Hand Transfer</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="hand_to_hand_transfer"
                                                            placeholder='Hand-To-Hand Transfer'
                                                            value={childProblems.hand_to_hand_transfer || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formSitting">
                                                        <Form.Label>Sitting</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="sitting"
                                                            placeholder='Sitting'
                                                            value={childProblems.sitting || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formPincerMovement">
                                                        <Form.Label>Pincer Movement</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="pincer_movement"
                                                            placeholder='Pincer Movement'
                                                            value={childProblems.pincer_movement || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formCrawling">
                                                        <Form.Label>Crawling</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="crawling"
                                                            placeholder='Crawling'
                                                            value={childProblems.crawling || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formRemoveCloth">
                                                        <Form.Label>Removes Clothes / Shoes</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="remove_clothes_shoes"
                                                            placeholder='Removes Clothes / Shoes'
                                                            value={childProblems.remove_clothes_shoes || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formStanding">
                                                        <Form.Label>Standing</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="standing"
                                                            placeholder='Standing'
                                                            value={childProblems.standing || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formFontanellae">
                                                        <Form.Label>Puts on Clothes / Shoes</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="puts_on_clothes_shoes"
                                                            placeholder='Puts on Clothes / Shoes'
                                                            value={childProblems.puts_on_clothes_shoes || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formWalking" className="col-6">
                                                        <Form.Label>Walking</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="walking"
                                                            placeholder='Walking'
                                                            value={childProblems.walking || ""}
                                                            onChange={(oEvent) => onChange(oEvent, childProblems, setChildProblems)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2" className="mt-3">
                                            <Accordion.Header>Developmental Behaviour</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group as={Col} controlId="formSpeech" className="mb-3">
                                                    <Form.Label>Speech</Form.Label>
                                                    <Form.Check label="Babbling" name="babbling" checked={developmentalBehaviour.babbling} onChange={onCheckboxChange} />
                                                    <Form.Check label="Words" name="words" checked={developmentalBehaviour.words} onChange={onCheckboxChange} />
                                                    <Form.Check label="Sentences" name="sentences" checked={developmentalBehaviour.sentences} onChange={onCheckboxChange} />
                                                    <Form.Check label="Retarded / Lisping / Stammering" name="retarded" checked={developmentalBehaviour.retarded} onChange={onCheckboxChange} />
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="formFeeding" className="mb-3">
                                                    <Form.Label>Feeding</Form.Label>
                                                    <Form.Check label="Breast" name="breast" checked={developmentalBehaviour.breast} onChange={onCheckboxChange} />
                                                    <Form.Check label="Top : Dilution" name="top_dilution" checked={developmentalBehaviour.top_dilution} onChange={onCheckboxChange} />
                                                    <Form.Check label="Bottle" name="bottle" checked={developmentalBehaviour.bottle} onChange={onCheckboxChange} />
                                                    <Form.Check label="Solids" name="solids" checked={developmentalBehaviour.solids} onChange={onCheckboxChange} />
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="formFeedingProblems" className="mb-3">
                                                    <Form.Label>Feeding Problems</Form.Label>
                                                    <Form.Check label="Colic" name="colic" checked={developmentalBehaviour.colic} onChange={onCheckboxChange} />
                                                    <Form.Check label="Underfeeding" name="underfeeding" checked={developmentalBehaviour.underfeeding} onChange={onCheckboxChange} />
                                                    <Form.Check label="Overfeeding" name="overfeeding" checked={developmentalBehaviour.overfeeding} onChange={onCheckboxChange} />
                                                    <Form.Check label="Regurgitation & Vomiting" name="regurgitation" checked={developmentalBehaviour.regurgitation} onChange={onCheckboxChange} />
                                                    <Form.Check label="Loose Stools" name="loose_stools" checked={developmentalBehaviour.loose_stools} onChange={onCheckboxChange} />
                                                    <Form.Check label="Constipation" name="constipation" checked={developmentalBehaviour.constipation} onChange={onCheckboxChange} />
                                                </Form.Group>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#examination" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Physical Examination</Accordion.Header>
                                            <Accordion.Body>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formWeight">
                                                        <Form.Label>Weight</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="weight"
                                                            placeholder='Weight'
                                                            value={physicalExamination.weight || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formHeight">
                                                        <Form.Label>Height</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="height"
                                                            placeholder='Height'
                                                            value={physicalExamination.height || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formPulse">
                                                        <Form.Label>Pulse</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="pulse"
                                                            placeholder='Pulse'
                                                            value={physicalExamination.pulse || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formBP">
                                                        <Form.Label>B.P.</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="bp"
                                                            placeholder='B.P.'
                                                            value={physicalExamination.bp || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formTempature">
                                                        <Form.Label>Tempature</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="tempature"
                                                            placeholder='Tempature'
                                                            value={physicalExamination.tempature || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formRS">
                                                        <Form.Label>RS</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="rs"
                                                            placeholder='RS'
                                                            value={physicalExamination.rs || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formCNS">
                                                        <Form.Label>CNS</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="cns"
                                                            placeholder='CNS'
                                                            value={physicalExamination.cns || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formCVS">
                                                        <Form.Label>CVS</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="cvs"
                                                            placeholder='CVS'
                                                            value={physicalExamination.cvs || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formPA">
                                                        <Form.Label>P/A</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="pa"
                                                            placeholder='P/A'
                                                            value={physicalExamination.pa || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formOthers">
                                                        <Form.Label>Others</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="others"
                                                            placeholder='Others'
                                                            value={physicalExamination.others || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="1" className={userDetails.clinic_type !== 'HM' ? "d-none" : "mt-3"} >
                                            <Accordion.Header>Mental State Examination</Accordion.Header>
                                            <Accordion.Body>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formAppearance">
                                                        <Form.Label>Appearance</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="appearance"
                                                            placeholder='Appearance'
                                                            value={physicalExamination.appearance || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formBehaviour">
                                                        <Form.Label>Behaviour</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="behaviour"
                                                            placeholder='Behaviour'
                                                            value={physicalExamination.behaviour || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formSpeech">
                                                        <Form.Label>Speech</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="speech"
                                                            placeholder='Speech'
                                                            value={physicalExamination.speech || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formMood">
                                                        <Form.Label>Mood</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="mood"
                                                            placeholder='Mood'
                                                            value={physicalExamination.mood || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formThought">
                                                        <Form.Label>Thought</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="thought"
                                                            placeholder='Thought'
                                                            value={physicalExamination.thought || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formPerception">
                                                        <Form.Label>Perception</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="perception"
                                                            placeholder='Perception'
                                                            value={physicalExamination.perception || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formMemory">
                                                        <Form.Label>Memory</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="memory"
                                                            placeholder='Memory'
                                                            value={physicalExamination.memory || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formOrientation">
                                                        <Form.Label>Orientation</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="orientation"
                                                            placeholder='Orientation'
                                                            value={physicalExamination.orientation || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formInsight" className="col-6">
                                                        <Form.Label>Insight / Judgement</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="insight_judgement"
                                                            placeholder='Insight / Judgement'
                                                            value={physicalExamination.insight_judgement || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#dental-examination" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0" className="mt-3">
                                            <Accordion.Header>Dental Chart</Accordion.Header>
                                            <Accordion.Body>
                                                <DentalChart dentalChartType={dentalChartType} dentalChart={dentalChart} onChange={(updatedChart) => setDentalChart(updatedChart)} />
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        {previousDentalChart.length > 0 &&
                                            <Accordion.Item eventKey="1" className="mt-3">
                                                <Accordion.Header>Past Dental Charts</Accordion.Header>
                                                <Accordion.Body>
                                                    <PreviousDentalChart previousDentalChart={previousDentalChart}
                                                        onChange={(updatedChart) => {
                                                            // Find the chart to update and update it in the state
                                                            const updatedCharts = previousDentalChart.map(chart =>
                                                                chart.chart_id === updatedChart.chart_id ? updatedChart : chart
                                                            );
                                                            setPreviousDentalChart(updatedCharts);
                                                        }} />
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        }

                                        <Accordion.Item eventKey="2" className="mt-3">
                                            <Accordion.Header>Oral Examination</Accordion.Header>
                                            <Accordion.Body>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formTeeth">
                                                        <Form.Label>Teeth</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="teeth"
                                                            placeholder='Teeth'
                                                            value={physicalExamination.teeth || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formTongue">
                                                        <Form.Label>Tongue</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="tongue"
                                                            placeholder='Tongue'
                                                            value={physicalExamination.tongue || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formExtraOral">
                                                        <Form.Label>Extra Oral</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="extra_oral"
                                                            placeholder='Extra Oral'
                                                            value={physicalExamination.extra_oral || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formIntraOral">
                                                        <Form.Label>Intra Oral</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="intra_oral"
                                                            placeholder='Intra Oral'
                                                            value={physicalExamination.intra_oral || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formGums">
                                                        <Form.Label>Gums</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="gums"
                                                            placeholder='Gums'
                                                            value={physicalExamination.gums || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formPalate">
                                                        <Form.Label>Palate</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="palate"
                                                            placeholder='Palate'
                                                            value={physicalExamination.palate || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formPharynx">
                                                        <Form.Label>Pharynx</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="pharynx"
                                                            placeholder='Pharynx'
                                                            value={physicalExamination.pharynx || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formTonsils">
                                                        <Form.Label>Tonsils</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="tonsils"
                                                            placeholder='Tonsils'
                                                            value={physicalExamination.tonsils || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formUvula" className="col-6">
                                                        <Form.Label>Uvula</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="uvula"
                                                            placeholder='Uvula'
                                                            value={physicalExamination.uvula || ""}
                                                            onChange={(oEvent) => onChange(oEvent, physicalExamination, setPhysicalExamination)}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#totality" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Totality of Symptoms</Accordion.Header>
                                            <Accordion.Body>
                                                <Button variant="outline-secondary" className='mb-3' onClick={() => onPressTableRowAdd('totality')}>
                                                    Add Row
                                                </Button>

                                                <Table bordered hover responsive>
                                                    <tbody>
                                                        {totality.map((item, index) => {
                                                            return [
                                                                <tr key={['totality', '-', index].join()} className="mb-3">
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={1}
                                                                            name="totality"
                                                                            value={item.totality || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.totality = oEvent.target.value;
                                                                                setTotality([...totality]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ]
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#diagnosis" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Diagnosis</Accordion.Header>
                                            <Accordion.Body>
                                                <Row className="align-items-center w-100 g-2">
                                                    <Col style={{ flex: 1 }}>
                                                        <Form.Group controlId="formDiagnosis1">
                                                            <Form.Control
                                                                type="text"
                                                                name="diagnosis_1"
                                                                placeholder='Diagnosis 1'
                                                                value={diagnosisRemedy.diagnosis_1 || ""}
                                                                onChange={(oEvent) => onChange(oEvent, diagnosisRemedy, setDiagnosisRemedy)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs="auto">
                                                        <Form.Group controlId="formICD1">
                                                            <Button variant="outline-secondary" onClick={oEvent => onPressOpenICD(oEvent, 1)}>ICD</Button>
                                                            <ModalICD show={isModalOpen['isModalOpen_diagnosis_1']}
                                                                onHide={() => setIsModalOpen({ ['isModalOpen_diagnosis_1']: false })}
                                                                onPressSelectCode={(selectedICD) => {
                                                                    setDiagnosisRemedy({
                                                                        ...diagnosisRemedy,
                                                                        diagnosis_1: selectedICD.code + ' - ' + selectedICD.short_description
                                                                    });
                                                                    setIsModalOpen({ ['isModalOpen_diagnosis_1']: false });
                                                                }} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row className="mt-3 align-items-center w-100 g-2">
                                                    <Col style={{ flex: 1 }}>
                                                        <Form.Group controlId="formDiagnosis2">
                                                            <Form.Control
                                                                type="text"
                                                                name="diagnosis_2"
                                                                placeholder='Diagnosis 2'
                                                                value={diagnosisRemedy.diagnosis_2 || ""}
                                                                onChange={(oEvent) => onChange(oEvent, diagnosisRemedy, setDiagnosisRemedy)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs="auto">
                                                        <Form.Group controlId="formICD2">
                                                            <Button variant="outline-secondary" onClick={oEvent => onPressOpenICD(oEvent, 2)}>ICD</Button>
                                                            <ModalICD show={isModalOpen['isModalOpen_diagnosis_2']}
                                                                onHide={() => setIsModalOpen({ ['isModalOpen_diagnosis_2']: false })}
                                                                onPressSelectCode={(selectedICD) => {
                                                                    setDiagnosisRemedy({
                                                                        ...diagnosisRemedy,
                                                                        diagnosis_2: selectedICD.code + ' - ' + selectedICD.short_description
                                                                    });
                                                                    setIsModalOpen({ ['isModalOpen_diagnosis_2']: false });
                                                                }} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row className="mt-3 align-items-center w-100 g-2">
                                                    <Col style={{ flex: 1 }}>
                                                        <Form.Group controlId="formDiagnosis3">
                                                            <Form.Control
                                                                type="text"
                                                                name="diagnosis_3"
                                                                placeholder='Diagnosis 3'
                                                                value={diagnosisRemedy.diagnosis_3 || ""}
                                                                onChange={(oEvent) => onChange(oEvent, diagnosisRemedy, setDiagnosisRemedy)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs="auto">
                                                        <Form.Group controlId="formICD3">
                                                            <Button variant="outline-secondary" onClick={oEvent => onPressOpenICD(oEvent, 3)}>ICD</Button>
                                                            <ModalICD show={isModalOpen['isModalOpen_diagnosis_3']}
                                                                onHide={() => setIsModalOpen({ ['isModalOpen_diagnosis_3']: false })}
                                                                onPressSelectCode={(selectedICD) => {
                                                                    setDiagnosisRemedy({
                                                                        ...diagnosisRemedy,
                                                                        diagnosis_3: selectedICD.code + ' - ' + selectedICD.short_description
                                                                    });
                                                                    setIsModalOpen({ ['isModalOpen_diagnosis_3']: false });
                                                                }} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row className="mt-3 align-items-center w-100 g-2">
                                                    <Col style={{ flex: 1 }}>
                                                        <Form.Group controlId="formDiagnosis4">
                                                            <Form.Control
                                                                type="text"
                                                                name="diagnosis_4"
                                                                placeholder='Diagnosis 4'
                                                                value={diagnosisRemedy.diagnosis_4 || ""}
                                                                onChange={(oEvent) => onChange(oEvent, diagnosisRemedy, setDiagnosisRemedy)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs="auto">
                                                        <Form.Group controlId="formICD4">
                                                            <Button variant="outline-secondary" onClick={oEvent => onPressOpenICD(oEvent, 4)}>ICD</Button>
                                                            <ModalICD show={isModalOpen['isModalOpen_diagnosis_4']}
                                                                onHide={() => setIsModalOpen({ ['isModalOpen_diagnosis_4']: false })}
                                                                onPressSelectCode={(selectedICD) => {
                                                                    setDiagnosisRemedy({
                                                                        ...diagnosisRemedy,
                                                                        diagnosis_4: selectedICD.code + ' - ' + selectedICD.short_description
                                                                    });
                                                                    setIsModalOpen({ ['isModalOpen_diagnosis_4']: false });
                                                                }} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1" className="mt-3">
                                            <Accordion.Header>Investigation</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Control as="textarea" rows={9}
                                                    name="investigation"
                                                    placeholder='Investigation'
                                                    value={diagnosisRemedy.investigation || ""}
                                                    onChange={(oEvent) => onChange(oEvent, diagnosisRemedy, setDiagnosisRemedy)}
                                                />
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2" className="mt-3">
                                            <Accordion.Header>Prescription / Rx</Accordion.Header>
                                            <Accordion.Body>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={9}
                                                        name="remedy"
                                                        placeholder='Prescription / Rx'
                                                        value={diagnosisRemedy.remedy || ""}
                                                        onChange={(e) => onChange(e, diagnosisRemedy, setDiagnosisRemedy)} />

                                                    <Button
                                                        variant="outline-secondary"
                                                        className="position-absolute top-0 end-0 mt-2 me-2 z-3"
                                                        onClick={() => {
                                                            setActiveRxType("main");
                                                            setMedicineModalOpen(true);
                                                        }}
                                                    ><Pill size={18} /> Add Medicine</Button>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="3" className="mt-3">
                                            <Accordion.Header>Advice</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Control as="textarea" rows={9}
                                                    name="advice"
                                                    placeholder='Advice'
                                                    value={diagnosisRemedy.advice || ""}
                                                    onChange={(oEvent) => onChange(oEvent, diagnosisRemedy, setDiagnosisRemedy)}
                                                />
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="4" className="mt-3">
                                            <Accordion.Header>Next Visit Appointment</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group className="mb-3" controlId="formAppointmentDate">
                                                    <Form.Label>Appointment Date</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="appointment_date"
                                                        disabled={isNextAppointmentDisabled}
                                                        value={diagnosisRemedy.next_appointment_date || ""}
                                                        onChange={(oEvent) => {
                                                            setDiagnosisRemedy({
                                                                ...diagnosisRemedy,
                                                                next_appointment_date: oEvent.target.value
                                                            });
                                                            setNextVisitPlan({
                                                                ...nextVisitPlan,
                                                                next_appointment_date: oEvent.target.value
                                                            });
                                                        }}
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-3" controlId="formAppointmentTime">
                                                    <Form.Label>Appointment Time</Form.Label>
                                                    <CustomTimePicker
                                                        controlId="formUpdateAppointmentTimePicker"
                                                        name="appointment_time"
                                                        disabled={isNextAppointmentDisabled}
                                                        value={diagnosisRemedy.next_appointment_time || ""}
                                                        onChange={(oEvent) => {
                                                            setDiagnosisRemedy({
                                                                ...diagnosisRemedy,
                                                                next_appointment_time: oEvent.target.value
                                                            });
                                                            setNextVisitPlan({
                                                                ...nextVisitPlan,
                                                                next_appointment_time: oEvent.target.value
                                                            });
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#other-notes" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Other Notes</Accordion.Header>
                                            <Accordion.Body>
                                                <Button variant="outline-secondary" className='mb-3' onClick={() => onPressTableRowAdd('otherNotes')}>
                                                    Add Row
                                                </Button>

                                                <Table bordered hover responsive>
                                                    <tbody>
                                                        {otherNotes.map((item, index) => {
                                                            return [
                                                                <tr key={['other_notes', '-', index].join()} className="mb-3">
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={1}
                                                                            name="other_notes"
                                                                            value={item.other_notes || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.other_notes = oEvent.target.value;
                                                                                setOtherNotes([...otherNotes]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ]
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#files" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Upload Patient Files</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group controlId="formFile">
                                                    <Form.Label>Choose File</Form.Label>
                                                    <Form.Control
                                                        ref={fileInputRef}
                                                        type="file"
                                                        name="file_url"
                                                        placeholder='Choose File'
                                                        accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx"
                                                        onChange={onFileChange}
                                                    />
                                                </Form.Group>
                                                <Row className="mt-3">
                                                    <Form.Group as={Col} controlId="formFileName">
                                                        <Form.Label>File Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="file_name"
                                                            placeholder='File Name'
                                                            value={formFile.file_name || ""}
                                                            onChange={(oEvent) => { setFormFile({ ...formFile, file_name: oEvent.target.value }); }}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formFileDate">
                                                        <Form.Label>Upload Date</Form.Label>
                                                        <Form.Control
                                                            type="date"
                                                            name="upload_date"
                                                            placeholder='Upload Date'
                                                            value={formFile.upload_date || ""}
                                                            onChange={(oEvent) => { setFormFile({ ...formFile, upload_date: oEvent.target.value }); }}
                                                        />
                                                    </Form.Group>
                                                </Row>
                                                <Form.Group controlId="formRemark" className="mt-3">
                                                    <Form.Label>Remark</Form.Label>
                                                    <Form.Control as="textarea" rows={2}
                                                        name="remark"
                                                        placeholder='Remark'
                                                        value={formFile.remark || ""}
                                                        onChange={(oEvent) => { setFormFile({ ...formFile, remark: oEvent.target.value }); }}
                                                    />
                                                </Form.Group>
                                                <Button disabled={!formFile.file_url || !formFile.upload_date} className="mt-3" onClick={onFileUpload}>Upload</Button>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="1" className="mt-3">
                                            <Accordion.Header>Uploaded Files</Accordion.Header>
                                            <Accordion.Body>
                                                <Table bordered hover responsive>
                                                    <thead light="true">
                                                        <th>#</th>
                                                        <th>Upload Date</th>
                                                        <th>File Name</th>
                                                        <th>File Type</th>
                                                        <th>Remark</th>
                                                        <th>View</th>
                                                        <th>Delete</th>
                                                    </thead>
                                                    <tbody>
                                                        {patientFiles.length > 0 ? (
                                                            <>
                                                                {patientFiles.map((item, index) => {
                                                                    return (
                                                                        <tr key={['patient_file', '-', index].join()} className="mb-3">
                                                                            <td>{index + 1}</td>
                                                                            <td>{formatDisplayDate(item.upload_date)}</td>
                                                                            <td>{item.file_name}</td>
                                                                            <td>{item.file_type}</td>
                                                                            <td>{item.remark}</td>
                                                                            <td>
                                                                                <Button size="sm" onClick={() => {
                                                                                    setPreviewFileType(item.file_type);
                                                                                    setPreviewUrl(item.signed_file_url);
                                                                                    setShowFileModal(true);
                                                                                }}>View</Button>
                                                                            </td>
                                                                            <td>
                                                                                <Button size="sm" variant="danger" onClick={oEvent => onPressDeleteFile(oEvent, item.file_id)} >Delete</Button>
                                                                                <ModalDelete show={isDeleteFileModalOpen['isDeleteFileModalOpen_' + item.file_id]} modalTitle="Patient File" modalBody={"Uploaded on " + formatDisplayDate(item.upload_date)}
                                                                                    onHide={() => setIsDeleteFileModalOpen({ ['isDeleteFileModalOpen_' + item.file_id]: false })}
                                                                                    onSubmit={oEvent => onPressSubmitDeleteFile(oEvent, item.file_id)} />
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </>
                                                        ) : <></>}
                                                    </tbody>
                                                </Table>

                                                <Modal show={showFileModal} onHide={() => setShowFileModal(false)} size="lg" centered>
                                                    <Modal.Body>
                                                        {/* Determine internal type */}
                                                        {(() => {
                                                            const previewType = mappedPreviewFileType(previewFileType);

                                                            if (previewType === "image") {
                                                                return (
                                                                    <img src={previewUrl} alt="Preview" style={{ width: '100%' }} />
                                                                );
                                                            }

                                                            if (previewType === "pdf") {
                                                                return (
                                                                    <iframe src={previewUrl} title="PDF Preview" style={{ width: "100%", height: "80vh", border: "none" }}></iframe>
                                                                );
                                                            }

                                                            if (previewType === "word") {
                                                                return (
                                                                    <iframe
                                                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewUrl)}`}
                                                                        title="Word Document Preview"
                                                                        style={{ width: "100%", height: "80vh", border: "none" }}
                                                                    ></iframe>
                                                                );
                                                            }

                                                            if (previewType === "excel") {
                                                                return (
                                                                    <iframe
                                                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewUrl)}`}
                                                                        title="Excel Spreadsheet Preview"
                                                                        style={{ width: "100%", height: "80vh", border: "none" }}
                                                                    ></iframe>
                                                                );
                                                            }

                                                            if (previewType === "powerpoint") {
                                                                return (
                                                                    <iframe
                                                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewUrl)}`}
                                                                        title="PowerPoint Preview"
                                                                        style={{ width: "100%", height: "80vh", border: "none" }}
                                                                    ></iframe>
                                                                );
                                                            }

                                                            return <p>Preview not available for this file type.</p>;
                                                        })()}
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button onClick={() => setShowFileModal(false)}>Close</Button>
                                                    </Modal.Footer>
                                                </Modal>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#evaluation" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Follow Up Evaluation</Accordion.Header>
                                            <Accordion.Body>
                                                <Button variant="outline-secondary" className='mb-3' onClick={() => onPressTableRowAdd('followUpEvaluation')}>
                                                    Add Row
                                                </Button>

                                                <Table bordered hover responsive>
                                                    <tbody>
                                                        {followUpEvaluation.map((item, index) => {
                                                            return [
                                                                <tr key={['follow_up_evaluation', '-', index].join()} className="mb-3">
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={1}
                                                                            name="follow_up_evaluation"
                                                                            value={item.follow_up_evaluation || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.follow_up_evaluation = oEvent.target.value;
                                                                                setFollowUpEvaluation([...followUpEvaluation]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ]
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>

                                <Tab.Pane eventKey="#follow-up" className='col-12'>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Follow Up</Accordion.Header>
                                            <Accordion.Body>
                                                <Button variant="outline-secondary" className='mb-3' onClick={() => onPressTableRowAdd('followUp')}>
                                                    Add Row
                                                </Button>

                                                <Table bordered hover responsive>
                                                    <thead light="true">
                                                        <tr>
                                                            <th style={{ width: "3rem", verticalAlign: 'text-top' }}>#</th>
                                                            <th style={{ width: "6rem", textAlign: 'center' }}>Follow Up Date</th>
                                                            <th style={{ minWidth: "10rem", textAlign: 'center' }}>Follow Up</th>
                                                            <th style={{ minWidth: "10rem", textAlign: 'center' }}>Rx</th>
                                                            <th style={{ textAlign: 'center' }}>Advice</th>
                                                            <th style={{ width: "5rem", textAlign: 'center' }}>Amount</th>
                                                            <th style={{ width: "7rem", textAlign: 'center' }}>Paid via</th>
                                                            <th style={{ width: "7rem", textAlign: 'center' }}>Next Appt. Date</th>
                                                            <th style={{ width: "10rem", textAlign: 'center' }}>Next Appt. Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {followUp.map((item, index) => {
                                                            return [
                                                                <tr key={['followUp', '-', index].join()} className="mb-3">
                                                                    <td>{index + 1}</td>
                                                                    <td>
                                                                        <Form.Control
                                                                            size="sm"
                                                                            type="date"
                                                                            name="follow_up_date"
                                                                            value={item.follow_up_date || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.follow_up_date = oEvent.target.value;
                                                                                setFollowUp([...followUp]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={2}
                                                                            size="sm"
                                                                            name="follow_up"
                                                                            value={item.follow_up || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.follow_up = oEvent.target.value;
                                                                                setFollowUp([...followUp]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <div className="position-relative">
                                                                            <Form.Control as="textarea" rows={2}
                                                                                size="sm"
                                                                                name="remedy"
                                                                                value={item.remedy || ""}
                                                                                onChange={(oEvent) => {
                                                                                    item.remedy = oEvent.target.value;
                                                                                    setFollowUp([...followUp]);
                                                                                }}
                                                                            />
                                                                            <Button
                                                                                size="sm"
                                                                                variant="outline-secondary"
                                                                                className="position-absolute bottom-0 end-0 mb-2 me-2 z-3 d-flex align-items-center gap-1"
                                                                                onClick={() => {
                                                                                    setActiveRxType(`followUp-${index}`);
                                                                                    setMedicineModalOpen(true);
                                                                                }}
                                                                            ><Pill size={16} /></Button>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control as="textarea" rows={2}
                                                                            size="sm"
                                                                            name="advice"
                                                                            value={item.advice || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.advice = oEvent.target.value;
                                                                                setFollowUp([...followUp]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            size="sm"
                                                                            type="text"
                                                                            name="amount"
                                                                            value={item.amount || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.amount = oEvent.target.value;
                                                                                setFollowUp([...followUp]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control as={FormSelect} size="sm"
                                                                            name="amount_paid_via"
                                                                            value={item.amount_paid_via || "cash"}
                                                                            onChange={(oEvent) => {
                                                                                item.amount_paid_via = oEvent.target.value;
                                                                                setFollowUp([...followUp]);
                                                                            }}
                                                                        >
                                                                            <option value="">Select Payment Method</option>
                                                                            <option value="cash">Cash</option>
                                                                            <option value="card">Card</option>
                                                                            <option value="upi">UPI</option>
                                                                            <option value="other">Other</option>
                                                                        </Form.Control>
                                                                    </td>
                                                                    <td>
                                                                        <Form.Control
                                                                            size="sm"
                                                                            type="date"
                                                                            name="next_appointment_date"
                                                                            value={item.next_appointment_date || ""}
                                                                            onChange={(oEvent) => {
                                                                                item.next_appointment_date = oEvent.target.value;
                                                                                setFollowUp([...followUp]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <CustomTimePicker
                                                                            size="sm"
                                                                            controlId={`next_appointment_time_${index}`}
                                                                            name="next_appointment_time"
                                                                            value={item.next_appointment_time || ""}
                                                                            wrapperClass="compact-timepicker"
                                                                            onChange={(oEvent) => {
                                                                                item.next_appointment_time = oEvent.target.value;
                                                                                setFollowUp([...followUp]);
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ]
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Tab.Pane>
                            </Tab.Content>

                            <footer className="footer fixed-bottom footer-transparent content container-fluid mr-3 mb-3"
                                style={{ width: 'fit-content' }}>
                                <div>
                                    {userDetails.is_clinic_plan_expired === false ? (
                                        <>
                                            <Button variant="primary" onClick={onPressSave} type="submit" className="mr-1" disabled={userDetails.user_type === "M" || isPatientSaved === true} >
                                                {isSubmitting ? 'Saving...' : 'Save'}
                                            </Button>

                                            {userDetails.user_type === "M" ?
                                                <Button variant='primary' onClick={onPressPrintPrescription} className="mr-1">Print Prescription</Button>
                                                :
                                                <Button variant='primary' onClick={onPressPrintPrescription} className="mr-1" disabled={isPatientSaved === false} >Print Prescription</Button>
                                            }
                                            {isPrescriptionModalOpen && (
                                                <PrescriptionModal
                                                    isOpen={isPrescriptionModalOpen}
                                                    onClose={() => setPrescriptionModalOpen(false)}
                                                    prescriptionDetails={prescriptionDetails}
                                                    patientEmailAddress={personalInformation.email_id} />
                                            )}
                                        </>
                                    ) : null}

                                    <Button variant="secondary" onClick={onPressCancel}>Close</Button>

                                    <ModalMedicine
                                        show={isMedicineModalOpen}
                                        handleClose={() => setMedicineModalOpen(false)}
                                        existingPrescriptions={
                                            activeRxType === 'main'
                                                ? diagnosisRemedy.remedy
                                                : followUp[activeRxType.split('-')[1]]?.remedy || ''
                                        }
                                        onSave={(data) => {
                                            if (activeRxType === 'main') {
                                                setDiagnosisRemedy({ ...diagnosisRemedy, remedy: data });
                                            } else {
                                                const index = activeRxType.split('-')[1];
                                                const updatedFollowUp = [...followUp];
                                                updatedFollowUp[index].remedy = data;
                                                setFollowUp(updatedFollowUp);
                                            }
                                            setMedicineModalOpen(false);
                                        }}
                                    ></ModalMedicine>
                                </div>
                            </footer>
                        </Form>
                    </div>
                </Row>
            </Tab.Container>
            <ToastContainer />
            <BusyLoaderOverlay show={loading} />
        </>
    )
}

export default NewPatient